<template>
  <div class="FunctionTable" v-if="show">
    <div>
      <div class="Commodity_box mg_4" v-if="visiblessl">
        <ScanInput
          ref="fooer"
          :visibles="visiblessl"
          @dateChange="dateChangeScan"
          v-bind="$attrs"
        ></ScanInput>
      </div>
    </div>
    <vxe-table
      :data="tableData"
      :align="align"
      highlight-cell
      :highlight-current-row="highlightcurrentrow"
      :border="border"
      :resizable="resizable"
      ref="xTable"
      :height="tableHeight"
      :footer-method="footerMethod"
      :show-footer="showfooter"
      show-overflow="ellipsis"
      show-header-overflow
      @cell-click="cellclick"
      @cell-dblclick="celldblclick"
      @resizable-change="resizablechange"
      :mouse-config="mouseconfig"
      :column-min-width="columnminwidth"
      :edit-config="{ trigger: 'dblclick', mode: 'cell', showStatus: true }"
      :checkbox-config="{ checkField: 'checked' }"
      :header-cell-style="{
        background: '#eef1f6',
        color: '#000',
        fontSize: '16px',
        height: '37px',
        padding: '0',
        fontWeight: 'bold',
      }"
      :footer-row-style="{
        background: '#eef1f6',
        color: '#000',
        fontSize: '14px',
        height: '30px',
        padding: '0',
      }"
      :footer-cell-style="{
        background: '#fff',
        color: '#000',
        fontSize: '14px',
        height: '30px',
        padding: '0',
      }"
    >
      <vxe-table-column type="index" align="center" width="45" fixed="left">
        <template v-slot:header>
          <i
            class="el-icon-s-tools"
            @click="tableConfigShow = true"
            style="color: #2594ff; font-size: 18px"
          ></i>
        </template>
        <template v-slot="{ column, rowIndex }">{{ rowIndex + 1 }}</template>
      </vxe-table-column>
      <vxe-table-column width="100" align="center" title="操作" fixed="left">
        <template v-slot="{ row, rowIndex }">
          <el-button type="text" @click.native.prevent="addRow(rowIndex + 1)"
            >新增</el-button
          >
          <el-button type="text" @click.native.prevent="deleteRow(rowIndex)"
            >移除</el-button
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="ImageUrlShow"
        title="图片"
        fixed="left"
        width="60"
      >
        <template v-slot="{ row }">
          <div
            style="
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
            "
          >
            <img
              v-if="row.ImageUrl"
              :src="row.ImageUrl"
              style="width: 26px; height: 26px; display: block"
              @click="imgclick(row.ImageUrl)"
            />
          </div>
        </template>
      </vxe-table-column>
      <template v-for="(item, index) in ObtainHeader">
        <vxe-table-column
          :width="item.Width == '' ? '200' : item.Width"
          :key="index"
          :field="item.Key"
          :title="item.Rename"
          v-if="item.Key === 'FullName' && item.Show == true"
        >
          <template v-slot="{ row, rowIndex }">
            <div class="input_box ub ub-ac">
              <input
                ref="Qtyfocus"
                autocomplete="off"
                :id="'x_' + rowIndex + '_y_' + index"
                size="mini"
                type="text"
                class="input_stys"
                v-model.lazy="row[item.Key]"
                @keyup.up="
                  UpArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    Obtain.length
                  )
                "
                @keyup.enter="
                  EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    Obtain.length
                  )
                "
                @keyup.down="
                  EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    Obtain.length
                  )
                "
                @keyup.37="
                  LeftArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    Obtain.length
                  )
                "
                @keyup.39="
                  EnterArrow(
                    row,
                    rowIndex,
                    index,
                    item.FirstOne,
                    item.LastOne,
                    Obtain.length
                  )
                "
                @keydown="EnterArrows"
                @dblclick="ChoiceClick"
                @focus="
                  doFocus(
                    $event,
                    row.BaseCode,
                    rowIndex,
                    item.Key,
                    row[item.Key],
                    row
                  )
                "
                @blur="
                  doblurs(
                    $event,
                    row.BaseCode,
                    rowIndex,
                    item.Key,
                    row[item.Key],
                    row
                  )
                "
                v-on:change="change(row[item.Key])"
              />
              <span
                v-if="
                  item.Key == 'FullName' &&
                  item.Show == true &&
                  rowIndex === rowIndexX
                "
                class="cliclicon el-icon-more"
                @click="ChoiceClick"
              ></span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          :width="item.Width == '' ? '200' : item.Width"
          :key="index"
          :field="item.Key"
          :title="item.Rename"
          v-if="item.Key === 'BaseCode' && item.Show == true"
        >
          <template v-slot:header>
            <div>
              {{ item.Rename }}
              <el-button class="btnclick" slot="reference" @click="clickbtn"
                >扫码录入</el-button
              >
            </div>
          </template>
          <template v-slot="{ row }">
            <div class="only_show_div">{{ row[item.Key] }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          :width="item.Width == '' ? '200' : item.Width"
          :key="index"
          :field="item.Key"
          :title="item.Rename"
          v-if="item.Key === 'UnitName' && item.Show == true"
        >
          <template v-slot="{ row, rowIndex }">
            <div class="box_popover" style="position: relative">
              <span class="only_show_div">{{ row[item.Key] }}</span>
              <el-popover
                v-model="visiblepopover"
                style="position: absolute; top: -3px; right: 10px"
                v-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'UnitName' &&
                  item.Show == true &&
                  rowIndex == rowIndexX &&
                  $attrs.pargam.Model != 'TakeStock'
                "
              >
                <div>
                  <vxe-table
                    border
                    highlight-hover-row
                    :data="rowUnitData"
                    @cell-click="cellclickddw"
                    height="200px"
                  >
                    <template v-for="(item, index) in ObtainHeaderddw">
                      <vxe-table-column
                        width="90"
                        :key="index"
                        :field="item.Key"
                        :title="item.Rename"
                        align="center"
                      ></vxe-table-column>
                    </template>
                  </vxe-table>
                </div>
                <span
                  slot="reference"
                  style="padding: 10px 0"
                  class="btnclicks el-icon-more"
                  @click="visiblepop(row)"
                  v-if="
                    row.FullName != '' &&
                    row.BaseCode != '' &&
                    item.Key == 'UnitName' &&
                    item.Show == true
                  "
                ></span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          :width="item.Width"
          :title="item.Rename"
          :field="item.Key"
          align="center"
          :key="index"
          v-if="
            item.Key != 'FullName' &&
            item.Key != 'BaseCode' &&
            item.Key != 'UnitName' &&
            item.Show == true
          "
        >
          <template v-slot="{ row, rowIndex }">
            <div class="input_box ub ub-ac">
              <div
                v-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'KtypeIdName' &&
                  $attrs.pargam.Model != 'TakeStock'
                "
                style="width: 100%; height: 100%"
                @dblclick="
                  clickAboveattrs(
                    row,
                    rowIndex,
                    index,
                    row.IsSerial,
                    row.CostType
                  )
                "
              >
                <!-- <input
                  v-if="row.FullName!='' && row.BaseCode!='' &&( item.Key=='KtypeIdName') && $attrs.pargam.Model!='TakeStock' && row.IsSerial==false "
                  size="mini"
                  ref="Qtyfocus"
                  :id="'x_'+rowIndex+'_y_'+index"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="UpArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @keyup.enter="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length,item.Key)"
                  @keyup.down="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @keyup.37="LeftArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @keyup.39="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  
                @keydown="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @focus="doFocu($event,row.BaseCode,row[item.Key])"
                  @blur="changeData(row,index,item.Key,row[item.Key],row.CostType,row.IsSerial)"
                />-->
                <div class="only_show_div">{{ row[item.Key] }}</div>
                <span
                  v-if="
                    $attrs.pargam.Model != 'SaleOrder' &&
                    $attrs.pargam.Model != 'BuyOrder' &&
                    rowIndex === rowIndexX
                  "
                  class="cliclicon el-icon-more"
                  @click="
                    clickAboveattrs(
                      row,
                      rowIndex,
                      index,
                      row.IsSerial,
                      row.CostType
                    )
                  "
                ></span>
              </div>
              <!--  -->
              <div
                v-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'Qty' &&
                  $attrs.pargam.Model != 'TakeStock'
                "
                @dblclick="
                  clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)
                "
                style="width: 100%; height: 100%"
              >
                <input
                  v-if="
                    row.FullName != '' &&
                    row.BaseCode != '' &&
                    item.Key == 'Qty' &&
                    $attrs.pargam.Model != 'TakeStock' &&
                    (row.IsSerial == false ||
                      $attrs.pargam.Model == 'SaleOrder' ||
                      $attrs.pargam.Model == 'BuyOrder')
                  "
                  size="mini"
                  ref="Qtyfocus"
                  :id="'x_' + rowIndex + '_y_' + index"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                  @blur="
                    changeData(
                      row,
                      index,
                      item.Key,
                      row[item.Key],
                      row.CostType,
                      row.IsSerial
                    )
                  "
                  @change.stop="
                    row[item.Key] = row[item.Key].replace(
                      /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                      '$1'
                    )
                  "
                />
                <div v-else class="only_show_div">{{ row[item.Key] }}</div>
                <!-- <div v-else class="only_show_div">{{$attrs.pargam.Model}}</div> -->
                <span
                  v-if="
                    $attrs.pargam.Model != 'SaleOrder' &&
                    $attrs.pargam.Model != 'BuyOrder' &&
                    rowIndex === rowIndexX
                  "
                  class="cliclicon el-icon-more"
                  @click="
                    clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)
                  "
                ></span>
              </div>
              <div
                v-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'AQty' &&
                  $attrs.pargam.Model == 'TakeStock'
                "
                @dblclick="
                  clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)
                "
                style="width: 100%; height: 100%"
              >
                <input
                  v-if="
                    row.FullName != '' &&
                    row.BaseCode != '' &&
                    item.Key == 'AQty' &&
                    $attrs.pargam.Model == 'TakeStock' &&
                    row.IsSerial == false
                  "
                  size="mini"
                  ref="Qtyfocus"
                  :id="'x_' + rowIndex + '_y_' + index"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                  @blur="
                    changeData(
                      row,
                      index,
                      item.Key,
                      row[item.Key],
                      row.CostType,
                      row.IsSerial
                    )
                  "
                  @change.stop="
                    row[item.Key] = row[item.Key].replace(
                      /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                      '$1'
                    )
                  "
                />
                <div v-else class="only_show_div">{{ row[item.Key] }}</div>
                <span
                  v-if="
                    $attrs.pargam.Model != 'SaleOrder' &&
                    $attrs.pargam.Model != 'BuyOrder' &&
                    rowIndex === rowIndexX
                  "
                  class="cliclicon el-icon-more"
                  @click="
                    clickAbove(row, rowIndex, index, row.IsSerial, row.CostType)
                  "
                ></span>
              </div>
              <!-- <div
                style="width: 100%;height: 100%;"
                v-else-if="row.FullName!=''&& row.BaseCode!='' &&( item.Key=='ATotal' || item.Key=='APrice'  ) &&row.PStutas!='赠品' && $attrs.pargam.Model=='TakeStock'"
              >
                <input
                  size="mini"
                  ref="Qtyfocus"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  :id="'x_'+rowIndex+'_y_'+index"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="UpArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @keyup.enter="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length,item.Key)"
                  @keyup.down="DwArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @keyup.37="LeftArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @keyup.39="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  
                @keydown="EnterArrow(row,rowIndex,index,item.FirstOne,item.LastOne,Obtain.length)"
                  @focus="doFocu($event,row.BaseCode,row[item.Key])"
                  @blur="changeData(row,index,item.Key,row[item.Key],row.CostType,row.IsSerial)"
                  @change.stop="row[item.Key]=row[item.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')"
                />
              </div>-->
              <div
                style="width: 100%; height: 100%"
                v-else-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'Total' &&
                  row.PStutas !== '赠品'
                "
              >
                <input
                  size="mini"
                  ref="Qtyfocus"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  :id="'x_' + rowIndex + '_y_' + index"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                  @blur="
                    changeData(
                      row,
                      index,
                      item.Key,
                      row[item.Key],
                      row.CostType,
                      row.IsSerial
                    )
                  "
                  @change.stop="
                    row[item.Key] = row[item.Key].replace(
                      /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                      '$1'
                    )
                  "
                />
              </div>
              <div
                style="width: 100%; height: 100%"
                v-else-if="
                  row.Name != '' &&
                  row.BaseCode != '' &&
                  (item.Key == 'Memo' ||
                    item.Key == 'BString1' ||
                    item.Key == 'BString2' ||
                    item.Key == 'BString3' ||
                    item.Key == 'BString4' ||
                    item.Key == 'BString5')
                "
              >
                <input
                  size="mini"
                  ref="Qtyfocus"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  :id="'x_' + rowIndex + '_y_' + index"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                />
              </div>
              <div
                style="width: 100%; height: 100%"
                v-else-if="
                  row.Name != '' &&
                  row.BaseCode != '' &&
                  (item.Key == 'Discount' ||
                    item.Key == 'DiscountPrice' ||
                    item.Key == 'DiscountTotal' ||
                    item.Key == 'WithTaxTotal' ||
                    item.Key == 'TaxPrice') &&
                  row.PStutas !== '赠品'
                "
              >
                <input
                  size="mini"
                  ref="Qtyfocus"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  :id="'x_' + rowIndex + '_y_' + index"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                  @blur="
                    changeData(
                      row,
                      index,
                      item.Key,
                      row[item.Key],
                      row.CostType,
                      row.IsSerial
                    )
                  "
                  @change.stop="
                    row[item.Key] = row[item.Key].replace(
                      /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                      '$1'
                    )
                  "
                />
              </div>
              <div
                style="width: 100%; height: 100%"
                v-else-if="
                  row.Name != '' &&
                  row.BaseCode != '' &&
                  row.PStutas != '赠品' &&
                  item.Key == 'Tax'
                "
              >
                <input
                  size="mini"
                  ref="Qtyfocus"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  :id="'x_' + rowIndex + '_y_' + index"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                  @blur="
                    changeData(
                      row,
                      index,
                      item.Key,
                      row[item.Key],
                      row.CostType,
                      row.IsSerial
                    )
                  "
                  @change.stop="
                    row[item.Key] = row[item.Key].replace(
                      /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                      '$1'
                    )
                  "
                />
              </div>
              <div
                v-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'JobNumber' &&
                  !CombineBatch &&
                  row.CostType == 1
                "
                @dblclick="clickJobNumber(row, rowIndex, index, row[item.Key])"
                style="width: 100%; height: 100%"
              >
                <input
                  v-if="
                    row.FullName != '' &&
                    row.BaseCode != '' &&
                    item.Key == 'JobNumber' &&
                    $attrs.pargam.Documenttype == 1 &&
                    row.CostType == 1 &&
                    $attrs.pargam.Model != 'BuyOrder' &&
                    $attrs.pargam.Model != 'SaleOrder'
                  "
                  size="mini"
                  ref="Qtyfocus"
                  :id="'x_' + rowIndex + '_y_' + index"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                />

                <div v-else class="only_show_div">{{ row[item.Key] }}</div>
                <span
                  v-if="
                    $attrs.pargam.Model != 'SaleOrder' &&
                    $attrs.pargam.Model != 'BuyOrder' &&
                    $attrs.pargam.Documenttype == 0 &&
                    rowIndex === rowIndexX &&
                    !CombineBatch
                  "
                  class="cliclicon el-icon-more"
                  @click="clickJobNumber(row, rowIndex, index, row[item.Key])"
                ></span>
              </div>

              <div
                v-else-if="
                  row.Name != '' && row.BaseCode != '' && item.Key == 'PStutas'
                "
                class="only_show_div"
              >
                <el-select
                  v-model="row[item.Key]"
                  placeholder="请选择"
                  size="mini"
                  @change="selcetChange($event, row, rowIndex)"
                >
                  <el-option label="非赠品" value="非赠品"></el-option>
                  <el-option label="赠品" value="赠品"></el-option>
                </el-select>
              </div>
              <div
                v-else-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  item.Key == 'ShowPrice' &&
                  row.PStutas !== '赠品'
                "
                @dblclick="Choicedj(row, rowIndex, index)"
                style="width: 100%; height: 100%"
              >
                <input
                  size="mini"
                  ref="Qtyfocus"
                  type="text"
                  class="input_stys"
                  autocomplete="off"
                  :id="'x_' + rowIndex + '_y_' + index"
                  v-model.lazy="row[item.Key]"
                  @keyup.up="
                    UpArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.enter="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length,
                      item.Key
                    )
                  "
                  @keyup.down="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.37="
                    LeftArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keyup.39="
                    EnterArrow(
                      row,
                      rowIndex,
                      index,
                      item.FirstOne,
                      item.LastOne,
                      Obtain.length
                    )
                  "
                  @keydown="EnterArrows"
                  @focus="doFocu($event, row.BaseCode, row[item.Key])"
                  @blur="
                    changeData(
                      row,
                      index,
                      item.Key,
                      row[item.Key],
                      row.CostType,
                      row.IsSerial
                    )
                  "
                  @change.stop="
                    row[item.Key] = row[item.Key].replace(
                      /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                      '$1'
                    )
                  "
                />
                <span
                  class="cliclicon el-icon-more"
                  v-if="rowIndex === rowIndexX"
                  @click="Choicedj(row, rowIndex, index)"
                ></span>
              </div>
              <div
                v-else-if="
                  row.FullName != '' &&
                  row.BaseCode != '' &&
                  (item.Key == 'OutFactoryDate' ||
                    item.Key == 'MaturityDate') &&
                  $attrs.pargam.Documenttype == 1 &&
                  !CombineBatch &&
                  row.CostType == 1 &&
                  $attrs.pargam.Model != 'BuyOrder' &&
                  $attrs.pargam.Model != 'SaleOrder'
                "
                style="width: 100%; height: 100%"
                class="input_box_picker"
              >
                <!-- :id="'x_'+rowIndex+'_y_'+index"
                 
                @blur="safafafafa($event, rowIndex,index)"-->
                <el-date-picker
                  ref="Qtyfocus"
                  type="date"
                  v-model.lazy="row[item.Key]"
                  value-format="yyyy-MM-dd"
                  @change="changepicker($event, row, item.Key, rowIndex)"
                  @focus="focuscilic($event, rowIndex, index, item.Key)"
                ></el-date-picker>
              </div>
              <div v-else class="only_show_div">{{ row[item.Key] }}</div>
            </div>
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <!-- 商品选择弹出框 -->
    <GoodsTables
      :textname="textname"
      ref="GoodsTables"
      :show.sync="searchShow"
      @dbclickRow="chooseBack"
      v-bind="$attrs"
      :tableDataPtyId="tableData"
      @chooseBack="chooseBack"
    />
    <!-- 数量 -->
    <SerialTable
      ref="SerialTable"
      :show.sync="SerialTableShow"
      v-bind="$attrs"
      :qtys="qtys"
      :vchtype="vchtype"
      :tableDatasl="tableDatasl"
      :tableDatarow="tableDatarow"
      @chooseBack="Databackfilling"
    />
    <Multiple
      ref="Multiple"
      :show.sync="MultipleShow"
      v-bind="$attrs"
      :qtys="qtys"
      :vchtype="vchtype"
      :tableDatasl="tableDatasl"
      :tableDatarow="tableDatarow"
      @chooseBack="Databackfilling"
    />
    <!-- 表格 -->
    <HeaderElastic
      :show.sync="tableConfigShow"
      :tableData="ObtainHeader"
      v-bind="$attrs"
      v-on="$listeners"
      @restoreDefault="restoreDefault"
    />
    <!-- 单位 -->
    <UnitPrice
      :show.sync="tableUnitPrice"
      @chooseBack="chooseBackUnitPrice"
      :searchData="searchData"
      v-bind="$attrs"
    />
    <!-- 商品库存批次情况 -->
    <batchDialog
      :show.sync="tablebatchDialog"
      v-bind="$attrs"
      :Goodsdata="Goodsdata"
      :tableData="GoodstableData"
      @chooseBack="chooseBackbatchDialog"
    />
    <!-- 商品库存批次情况 -->
    <batchDialog
      :show.sync="tablebatchDialogs"
      v-bind="$attrs"
      :Goodsdata="Goodsdata"
      :tableData="GoodstableData"
      @chooseBack="chooseBackbatchDialogs"
    />
    <!-- 仓库 -->
    <!-- <addDalog :show.sync="addShow" fieldData="value1" @backData="backData" v-bind="$attrs" /> -->
    <Searchpop
      :show.sync="addShow"
      :searchData="search_Data"
      @dbclickRow="choose_Back"
      v-bind="$attrs"
      @chooseBack="choose_Back"
    />

    <!-- 显示图片 -->
    <el-dialog :visible.sync="dialogVisible" class="image_sty">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>
<script>
let direction = 0;
let indexid = 0;
import Vue from "vue";
import dataConfig from "@/utils/data.js";
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      // 传入下一个弹出框的字段，包含标题，树状图url，表格url，过滤url
      search_Data: {
        title: "仓库",
        url1: "/index/Stock/getlist",
        url2: "/index/Stock/getAll",
        url3: "/index/Stock/search",
        classify: "Stock",
      },
      PtypeIddata: [],
      addShow: false, // 仓库是否可见
      tablebatchDialogs: false, //  商品 数据需要打开批次 选择框
      GoodtableData: [], //  商品 数据需要打开批次的数据
      ImageUrlShow: tool.getLocal("get_config").showPic, // 是否显示图片
      CombineBatch:
        tool.getLocal("get_config").CombineBatch &&
        this.$attrs.pargam.Documenttype == 0 &&
        this.$attrs.pargam.Warehousetype == 10086, // 合并批次
      rowUnitData: [], // 单位数据  行
      visiblepopover: false, // 单位弹框是否弹出
      dialogVisible: false, //图片放大
      dialogImageUrl: "", // 图片路径
      Goodsdata: {}, // 批次数据
      vchtype: 0, // 数量判断显示类型
      qtys: "0.00", // 数量合计
      tableDatasl: [], // 数量数据
      tableDatarow: {}, // 数量当前数据
      GoodstableData: [],
      visiblessl: false,
      value1: false, //实验 可拖动弹框
      cities: [
        { value: "Beijing", label: "北京" },
        { value: "Shanghai", label: "上海" },
        { value: "Nanjing", label: "南京" },
        { value: "Chengdu", label: "成都" },
        { value: "Shenzhen", label: "深圳" },
        { value: "Guangzhou", label: "广州" },
      ], // 单位
      ObtainHeaderddw: [
        { Key: "UnitId", Rename: "序号" },
        { Key: "UnitName", Rename: "单位" },
      ], // 多单位 表头
      value: "",
      tableDatasd: [],
      checked: false, //是否录入数量
      CommodityBaseCode: "", //商品条码
      CommodityQty: "1", // 数量
      visibless: false, //录入条码框是否显示
      visibles: false, //录入条码框是否显示
      textname: "",
      indexid: indexid,
      direction: 0,
      diredire: 0,
      show: true,
      tableUnitPrice: false,
      // 状态值
      tablebatchDialog: false, // 是否显示批次情况弹框
      tableConfigShow: false, //是否显示表头配置弹出框
      SerialTableShow: false, //数量弹框
      MultipleShow: false, //数量弹框
      visible: true, // 模糊查询是否显示
      searchShow: false, //选择弹出框是否显示
      Data: this.tableData, // 表格数据
      ObtainHeader: this.Obtain, // 表格表头数据
      seaechGoodsShow: false, //商品选择弹出框是否显示
      tableHeadData: dataConfig.CustomConfig, // 模糊查询表格数据
      TableDataS: [], // 模糊查询数据
      mouseconfig: { selected: false }, // 是否开启点击单元格新增边框线
      timer: null,
      loading: false,
      focusinputa: "",
      FullNameName: "",
      searchData: {},
      MaturityDateOutFactoryDate: "", //日期框数据 回填需要
      fsafaff: [],
      rowIndexX: "", // 坐标
      indexy: "", // 坐标
    };
  },
  props: {
    tableHeight: {
      type: String,
      default: "350px", //window.innerHeight - 400 + "px"
    }, // 动态高度
    tableData: {
      type: Array,
      default: function () {
        return tableData;
      },
    },
    Obtain: Array,
    highlightcurrentrow: { type: Boolean, default: true }, // 是否显示高亮  为false current-change不生效
    border: { type: Boolean, default: true }, // 是否显示边框线
    resizable: { type: Boolean, default: true }, // 是否允许拖动列宽
    align: { type: String, default: "center" }, // 所有列对其方式  left（左对齐）, center（居中对齐）, right（右对齐）
    // loading: { type: Boolean, default: false }, // 是否允许加载loading显示
    showfooter: { type: Boolean, default: true }, // 是否允许显示合计
    footerNames: {
      type: Array,
      default: function () {
        return [
          "Qty",
          "AQty",
          "ATotal",
          "Total",
          "DiscountTotal",
          "TaxTotal",
          "WithTaxTotal",
        ];
      },
    }, // 需要合计的字段
    showoverflow: { type: String, default: "ellipsis" }, // 设置所有内容过长时显示为省略号 ellipsis（只显示省略号）,title（并且显示为原生 title）,tooltip（并且显示为 tooltip 提示）
    columnminwidth: { type: Number, default: 200 }, //所有最小<span class="keyword-lighten">列</span>宽度；会自动将剩余空间按比例分配
  },
  methods: {
    closetab(index) {
      //根据index删除tab组中的tab
      this.$refs.tgroup.remove(index);
    },
    choose_Back(row) {
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        KtypeId: row.KtypeId,
        PtypeId: this.tableData[this.rowIndexX].BaseNo,
        KFlag: 1,
        Stoped: this.$attrs.pargam.Stoped,
        Model: this.$attrs.pargam.Model,
        BuySale: this.$attrs.pargam.BuySale,
        BtypeId: this.$attrs.pargam.BtypeId,
      };
      this.request
        .post("/index/Goods/search", { jparams: JSON.stringify(params) })
        .then((res) => {
          this.chooseBack(res.data);
          // if (condition) {

          this.tableData[this.rowIndexX].KtypeIdName = row.FullName;
          this.tableData[this.rowIndexX].KtypeId = row.KtypeId;
          // }
          // this.tableData[this.rowIndexX].AQty = res.data[0].AQty;
        })
        .catch((err) => {});
    },
    clickAboveattrs(row, indexrow, index, IsSerial, CostType) {
      this.rowIndexX = indexrow;
      this.indexy = index;
      this.addShow = true;
    },
    // 生产到期日期
    changepicker(row, data, Key, rowIndex) {
      // DateType 时间类型 0 日 1 月 2 年 生产 OutFactoryDate  到期  MaturityDate
      // 获取指定日期前一天后一天 -1 前一天  1 后一天
      function getNextDate(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10
            ? "0" + (dd.getMonth() + 1)
            : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
      }
      if (Key == "MaturityDate" && row != null) {
        // 天  d
        if (data.DateType == 0) {
          if (data.UseFullLifeDay == 0) {
            this.tableData[rowIndex].OutFactoryDate = row;
            this.tableData[rowIndex].MaturityDate = row;
          } else {
            this.tableData[rowIndex].OutFactoryDate = getNextDate(
              tool.DateAdds("d", data.UseFullLifeDay, row, false),
              1
            );
          }
        }
        // 月  m
        if (data.DateType == 1) {
          if (data.UseFullLifeDay == 0) {
            this.tableData[rowIndex].OutFactoryDate = row;
            this.tableData[rowIndex].MaturityDate = row;
          } else {
            this.tableData[rowIndex].OutFactoryDate = getNextDate(
              tool.DateAdds("m", data.UseFullLifeDay, row, false),
              1
            );
          }
        }
        // 年 y
        if (data.DateType == 2) {
          if (data.UseFullLifeDay == 0) {
            this.tableData[rowIndex].OutFactoryDate = row;
            this.tableData[rowIndex].MaturityDate = row;
          } else {
            this.tableData[rowIndex].OutFactoryDate = getNextDate(
              tool.DateAdds("y", data.UseFullLifeDay, row, false),
              1
            );
          }
        }
      }
      if (Key == "OutFactoryDate" && row != null) {
        // 天  d
        if (data.DateType == 0) {
          if (data.UseFullLifeDay == 0) {
            this.tableData[rowIndex].OutFactoryDate = row;
            this.tableData[rowIndex].MaturityDate = row;
          } else {
            this.tableData[rowIndex].MaturityDate = getNextDate(
              tool.DateAdds("d", data.UseFullLifeDay, row, true),
              -1
            );
          }
        }
        // 月  m
        if (data.DateType == 1) {
          if (data.UseFullLifeDay == 0) {
            this.tableData[rowIndex].OutFactoryDate = row;
            this.tableData[rowIndex].MaturityDate = row;
          } else {
            this.tableData[rowIndex].MaturityDate = getNextDate(
              tool.DateAdds("m", data.UseFullLifeDay, row, true),
              -1
            );
          }
        }
        // 年 y
        if (data.DateType == 2) {
          if (data.UseFullLifeDay == 0) {
            this.tableData[rowIndex].OutFactoryDate = row;
            this.tableData[rowIndex].MaturityDate = row;
          } else {
            this.tableData[rowIndex].MaturityDate = getNextDate(
              tool.DateAdds("y", data.UseFullLifeDay, row, true),
              -1
            );
          }
        }
      }
      this.$refs.xTable.updateData();
    },
    // 查看图片
    imgclick(ImageUrl) {
      this.dialogImageUrl = ImageUrl;
      this.dialogVisible = true;
    },
    // 单位数据
    visiblepop(row) {
      this.rowUnitData = row.UnitData;
      setTimeout(() => {
        this.visiblepopover = true;
      }, 100);
    },
    // 批次号
    chooseBackbatchDialogs(row, tableDataGoods) {
      this.tableData.map((item, index) => {
        if (item.BaseNo == tableDataGoods.BaseNo && item.JobNumber == "") {
          item.JobNumberDatas = row;
          item.GoodsBaseNo = row.GoodsBaseNo;
          item.MaturityDate = row.MaturityDate;
          // item.ShowPrice = row.Price;
          item.OutFactoryDate = row.OutFactoryDate;
          if (row.JobNumber == "") {
            item.JobNumber = "未命名";
          } else {
            item.JobNumber = row.JobNumber;
          }
          this.$refs.xTable.setCurrentRow(item);
        }
      });
      if (tableDataGoods.IsSerial == true) {
        let ShelfIds = 0;
        if (tableDataGoods.ShelfId == undefined) {
          ShelfIds = 0;
        } else {
          ShelfIds = tableDataGoods.ShelfId;
        }
        let invid;
        if (this.$attrs.pargam.InvId == undefined) {
          invid = 0;
        } else {
          invid = this.$attrs.pargam.InvId;
        }
        let jparams = {
          InvId: invid, // 盘点单 InvID没有投就传l
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          KtypeId: this.$attrs.warehouseVal1.KtypeId,
          ShelfId: ShelfIds,
          PtypeId: tableDataGoods.PtypeId,
          GoodsBaseNo: tableDataGoods.GoodsBaseNo,
          Unit: tableDataGoods.Unit,
        };
        this.request
          .post("/index/Goods/get_SerialNo", {
            jparams: JSON.stringify(jparams),
          })
          .then((res) => {
            if (this.$attrs.pargam.Model == "TakeStock") {
              tableDataGoods.AQty = 0;
              tableDataGoods.Qty = row.Qty;
            } else {
              tableDataGoods.Qty = 0;
              tableDataGoods.UnitData.forEach((item) => {
                if (tableDataGoods.UnitName == item.UnitName) {
                  tableDataGoods.AQty = (
                    Number(row.Qty) / Number(item.Percent)
                  ).toFixed(tool.getLocal("get_config").moneyPoint);
                }
              });
            }
            tableDataGoods.SerialNo = res.data;
          })
          .catch((err) => {});
      } else {
        tableDataGoods.UnitData.forEach((item) => {
          if (tableDataGoods.UnitName == item.UnitName) {
            tableDataGoods.AQty = (
              Number(row.Qty) / Number(item.Percent)
            ).toFixed(tool.getLocal("get_config").moneyPoint);
          }
        });
        if (this.$attrs.pargam.Model == "TakeStock") {
          this.tableData[this.direction].AQty = 0;
          this.tableData[this.direction].Qty = data.Qty;
        }
      }
      if (this.$attrs.pargam.Model == "ChangePrice") {
        this.tableData[this.rowIndexX].ShowPrice = row.Price;
      }
      if (this.$attrs.pargam.Model == "TakeStock") {
        this.tableData[this.rowIndexX].APrice = row.Price;
        this.QtyTotalPrice(this.tableData[this.rowIndexX], row.Qty);
      }
    },
    // 批次号
    chooseBackbatchDialog(data) {
      this.tableData[this.direction].JobNumberDatas = data;
      this.tableData[this.direction].GoodsBaseNo = data.GoodsBaseNo;
      this.tableData[this.direction].MaturityDate = data.MaturityDate;
      this.tableData[this.direction].OutFactoryDate = data.OutFactoryDate;
      if (data.JobNumber == "") {
        this.tableData[this.direction].JobNumber = "未命名";
      } else {
        this.tableData[this.direction].JobNumber = data.JobNumber;
      }
      if (this.tableData[this.direction].IsSerial == true) {
        let ShelfIds = 0;
        if (this.tableData[this.direction].ShelfId == undefined) {
          ShelfIds = 0;
        } else {
          ShelfIds = this.tableData[this.direction].ShelfId;
        }
        let invid;
        if (this.$attrs.pargam.InvId == undefined) {
          invid = 0;
        } else {
          invid = this.$attrs.pargam.InvId;
        }
        let jparams = {
          InvId: invid, // 盘点单 InvID没有投就传l
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          KtypeId: this.$attrs.warehouseVal1.KtypeId,
          ShelfId: ShelfIds,
          PtypeId: this.tableData[this.direction].PtypeId,
          GoodsBaseNo: this.tableData[this.direction].GoodsBaseNo,
          Unit: this.tableData[this.direction].Unit,
        };
        this.request
          .post("/index/Goods/get_SerialNo", {
            jparams: JSON.stringify(jparams),
          })
          .then((res) => {
            if (this.$attrs.pargam.Model == "TakeStock") {
              this.tableData[this.direction].AQty = 0;
              this.tableData[this.direction].Qty = data.Qty;
            } else {
              this.tableData[this.direction].Qty = 0;
              this.tableData[this.direction].UnitData.forEach((item) => {
                if (this.tableData[this.direction].UnitName == item.UnitName) {
                  this.tableData[this.direction].AQty = (
                    Number(data.Qty) / Number(item.Percent)
                  ).toFixed(tool.getLocal("get_config").moneyPoint);
                }
              });
            }
            this.tableData[this.direction].SerialNo = res.data;
          })
          .catch((err) => {});
      } else {
        this.tableData[this.direction].UnitData.forEach((item) => {
          if (this.tableData[this.direction].UnitName == item.UnitName) {
            this.tableData[this.direction].AQty = (
              Number(data.Qty) / Number(item.Percent)
            ).toFixed(tool.getLocal("get_config").moneyPoint);
          }
        });
        if (this.$attrs.pargam.Model == "TakeStock") {
          this.tableData[this.direction].AQty = 0;
          this.tableData[this.direction].Qty = data.Qty;
        }
      }
      if (this.$attrs.pargam.Model == "ChangePrice") {
        this.tableData[this.rowIndexX].ShowPrice = data.Price;
      }
      if (this.$attrs.pargam.Model == "TakeStock") {
        this.tableData[this.rowIndexX].APrice = data.Price;
        this.QtyTotalPrice(this.tableData[this.rowIndexX], data.Qty);
      }
    },
    // 数量数据回填
    Databackfilling(qty, vchtype, Total, Qtys) {
      if (this.$attrs.pargam.Model != "TakeStock") {
        if (vchtype == 1) {
          setTimeout(() => {
            // this.tableData[this.direction].TotalPrice = Total;
            this.tableData[this.direction].MQty = Number(Total).toFixed(
              tool.getLocal("get_config").moneyPoint
            ); //主数量
            this.tableData[this.direction].Qty = Number(Qtys).toFixed(
              tool.getLocal("get_config").moneyPoint
            ); // 数量
            this.tableData[this.direction].UnitData = qty; //数量数据
            if (Number(Qtys) != 0) {
              this.QtyTotalPrice(this.tableData[this.direction], Number(Qtys));
            }
          }, 100);
        }
        if (vchtype == 2) {
          setTimeout(() => {
            this.QtyTotalPrice(
              this.tableData[this.direction],
              Number(qty.length)
            );
            this.tableData[this.direction].Qty = Number(qty.length).toFixed(
              tool.getLocal("get_config").moneyPoint
            );
            this.tableData[this.direction].SerialNotemporary = qty;
            this.tableData[this.direction].MQty = Number(qty.length).toFixed(
              tool.getLocal("get_config").moneyPoint
            );
            // if (this.tableData[this.direction].SerialNo == undefined) {
            //   this.tableData[this.direction].SerialNo = qty;
            // } else {
            // 数组合并
            // }
            var ars = this.tableData[this.direction].SerialNo.concat(qty);
            // 数组去重  双重for 循环去重
            for (let i = 0; i < ars.length; i++) {
              for (var j = i + 1; j < ars.length; j++) {
                if (ars[i].sn == ars[j].sn) {
                  ars[i].Show = true;
                  ars[j].Show = true;
                  ars.splice(j, 1);
                  j--;
                }
              }
            }
            this.tableData[this.direction].SerialNo = ars;
          }, 100);
        }
      } else {
        if (vchtype == 1) {
          setTimeout(() => {
            this.tableData[this.direction].MQty = Number(Total).toFixed(
              tool.getLocal("get_config").moneyPoint
            );
            this.tableData[this.direction].AQty = Number(Total).toFixed(
              tool.getLocal("get_config").moneyPoint
            );
            this.tableData[this.direction].UnitData = qty;
            this.QtyTotalPrice(this.tableData[this.direction], Total);
          }, 100);
        }
        if (vchtype == 2) {
          setTimeout(() => {
            this.tableData[this.direction].AQty = qty.length.toFixed(
              tool.getLocal("get_config").moneyPoint
            );
            this.tableData[this.direction].SerialNotemporary = qty;
            this.tableData[this.direction].MQty = qty.length.toFixed(
              tool.getLocal("get_config").moneyPoint
            );
            this.QtyTotalPrice(this.tableData[this.direction], qty.length);
            var ars = this.tableData[this.direction].SerialNo.concat(qty);
            // 数组去重  双重for 循环去重
            for (let i = 0; i < ars.length; i++) {
              for (var j = i + 1; j < ars.length; j++) {
                if (ars[i].sn == ars[j].sn) {
                  ars[i].Show = true;
                  ars[j].Show = true;
                  ars.splice(j, 1);
                  j--;
                }
              }
            }
            this.tableData[this.direction].SerialNo = ars;
          }, 100);
        }
      }
    },
    // 复合数量
    Reunitwithdata(qty, Qty, UnitName) {
      // function compare(property) {
      //   return function(a, b) {
      //     var value1 = a[property];
      //     var value2 = b[property];
      //     return value1 - value2;
      //   };
      // }
      /*
       *      参数： UnitNameData:单位数组
       *      参数： Qty:输入的数量
       *      参数： UnitName:当前单位
       **/
      if (this.$attrs.pargam.Model == "TakeStock") {
        return;
      }
      let Reunite = ""; //复合数量最终值 需要返回
      let Total = Number(""); //总数量
      let UnitNameDatas = qty;
      // qty = qty.sort(compare("Percent"));
      qty.forEach((item) => {
        // 获取总数
        if (item.UnitName == UnitName) {
          Total = Number((Number(item.Percent) * Number(Qty)).toFixed(2));
        }
      });
      this.tableDatasl = qty;
      // let Reunite = ""; // 复合数量
      let QtyData = "";
      let data = [];
      let DataTotal = Total;
      // 复合数量
      if (qty.length > 1) {
        DataTotals(Total, qty);
      } else {
        Reunite = Total + qty[0].UnitName;
      }
      function DataTotals(e, ary) {
        data = [];
        DataTotal = e;
        ary.forEach((item) => {
          if (item.UnitName != ary[ary.length - 1].UnitName) {
            data.push(item);
          } else if (item.UnitName == ary[ary.length - 1].UnitName) {
            if (Number(DataTotal) < Number(item.Percent)) {
              if (ary.length == 1 && ary.length != 0) {
                if (Number(DataTotal) != 0) {
                  Reunite += Number(DataTotal.toFixed(2)) + item.UnitName;
                }
              } else {
                if (parseInt(Number(DataTotal) / Number(item.Percent)) != 0) {
                  Reunite +=
                    parseInt(Number(DataTotal) / Number(item.Percent)) +
                    item.UnitName;
                }
              }
              DataTotals(DataTotal, data);
            } else {
              if (ary.length == 1) {
                if (Number(DataTotal) != 0) {
                  Reunite += Number(DataTotal.toFixed(2)) + item.UnitName;
                  return;
                }
              }
              Reunite +=
                parseInt(Number(DataTotal) / Number(item.Percent)) +
                item.UnitName;
              DataTotal =
                Number(DataTotal) -
                parseInt(Number(DataTotal) / Number(item.Percent)) *
                  Number(item.Percent);

              DataTotals(DataTotal, data);
            }
          }
        });
      }
      return Reunite;
    },
    // 点击录入商品 数据回填
    dateChangeScan(val, qty, checked) {
      if (
        this.$attrs.pargam.Model != "SaleOrder" &&
        this.$attrs.pargam.Model != "BuyOrder"
      ) {
        if (this.$attrs.pargam.Documenttype == 0 && val.CostType == 1) {
          this.Goodsdata = val;
          this.GoodstableData = [val];
          this.tablebatchDialogs = true;
        }
      }
      for (let index = 0; index < this.tableData.length; index++) {
        const item = this.tableData[index];

        if (item.FullName == "" && item.PtypeId == "") {
          if (checked) {
            if (!val.IsSerial) {
              if (this.$attrs.pargam.Model != "TakeStock") {
                val.Qty = qty;
              } else {
                val.APrice = val.ShowPrice;
                val.AQty = qty;
              }
              val.MQty = Number(qty) * Number(val.Percent);
            } else {
            }
            this.tableData.splice(index, 0, val);
            this.QtyTotalPrice(this.tableData[index], qty);
            return;
          } else {
            val.APrice = val.ShowPrice;
            this.tableData.splice(index, 0, val);
            return;
          }
        }
        if (this.tableData.length == index + 1) {
          this.$emit("addback", index + 1);
        }
      }
    },
    // 点击录入商品
    clickbtn(val) {
      this.visiblessl = !this.visiblessl;
      if (this.visiblessl) {
        setTimeout(() => {
          this.$refs.fooer.visiblefocus();
        }, 200);
      }
    },
    // 点击批次号
    clickJobNumber(row, indexrow, index, qty) {
      if (
        this.$attrs.pargam.Model != "SaleOrder" &&
        this.$attrs.pargam.Model != "BuyOrder" &&
        this.$attrs.pargam.Documenttype == 0
      ) {
        this.Goodsdata = row;
        this.tablebatchDialog = true;
      }
    },
    // 点击数量
    clickAbove(row, indexrow, index, IsSerial, CostType) {
      if (
        this.$attrs.pargam.Model != "SaleOrder" &&
        this.$attrs.pargam.Model != "BuyOrder"
      ) {
        this.rowIndexX = indexrow;
        this.indexy = index;
        this.tableDatasl = [];
        this.tableDatarow = row;
        if (IsSerial == false) {
          this.vchtype = 1;
          this.tableDatasl = row.UnitData;
          this.tableDatarow = row;
          this.MultipleShow = true;
        } else {
          this.vchtype = 2;
          if (CostType == 0) {
            if (
              this.$attrs.pargam.Documenttype != 0 &&
              row.SerialNotemporary != undefined
            ) {
              this.tableDatasl.push(...row.SerialNotemporary);
              this.SerialTableShow = true;
            } else if (this.$attrs.pargam.Documenttype != 0) {
              this.tableDatasl = [];
              this.SerialTableShow = true;
            } else if (this.$attrs.pargam.Documenttype == 0) {
              console.log(row.SerialNo);
              this.tableDatasl = row.SerialNo;
              this.SerialTableShow = true;
            }
          } else {
            if (
              this.$attrs.pargam.Documenttype != 0 &&
              row.SerialNotemporary != undefined
            ) {
              this.tableDatasl.push(...row.SerialNotemporary);
            } else if (this.$attrs.pargam.Documenttype != 0) {
              this.tableDatasl = [];
            } else if (this.$attrs.pargam.Documenttype == 0) {
              this.tableDatasl = row.SerialNo;
            }
            this.SerialTableShow = true;
          }
        }
      }
    },
    // 单击选择单位行
    cellclickddw({ row }) {
      this.tableData[this.direction].UnitName = row.UnitName;
      this.tableData[this.direction].Unit = row.Unit;
      this.searchClicks();
      // if (this.tableData[this.direction].MQty != undefined) {
      // this.tableData[this.direction].Qty =
      //   Number(this.tableData[this.direction].MQty) / Number(row.Percent); //.toFixed(tool.getLocal("get_config").moneyPoint);
      // this.QtyTotalPrice(this.tableData[this.direction]);
      // }
      this.visiblepopover = false;
    },
    // 请求/index/Goods/search 拿到最新的价格
    searchClicks(newVal = 0) {
      let invid,
        Ktype_Id = 0;
      if (this.$attrs.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.$attrs.pargam.InvId;
      }
      if (
        this.tableData[this.rowIndexX].KtypeId == 0 &&
        this.tableData[this.rowIndexX].KtypeIdName == ""
      ) {
        Ktype_Id = this.$attrs.warehouseVal1.KtypeId;
      } else {
        Ktype_Id = this.tableData[this.rowIndexX].KtypeId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        KtypeId: Ktype_Id,
        // KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        // Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        // Stoped: this.$attrs.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        // BuySale: this.$attrs.pargam.BuySale,
        // BtypeId: this.$attrs.customerVal1.KtypeId,
        // PtypeId: this.tableData[this.direction].PtypeId,
        GoodsBaseNo: this.tableData[this.rowIndexX].GoodsBaseNo,
        Unit: this.tableData[this.rowIndexX].Unit,
        InvId: invid, // 盘点单 InvID没有投就传l
        // type: type //0显示层级结构 1不显示
        // KtypeId: row.KtypeId,
        PtypeId: this.tableData[this.rowIndexX].BaseNo,
        KFlag: 1,
        Stoped: this.$attrs.pargam.Stoped,
        Model: this.$attrs.pargam.Model,
        BuySale: this.$attrs.pargam.BuySale,
        BtypeId: this.$attrs.pargam.BtypeId,
      };
      this.request
        .post("/index/Goods/search", { jparams: JSON.stringify(params) })
        .then((res) => {
          if (this.$attrs.pargam.Model == "TakeStock") {
            this.tableData[this.rowIndexX].APrice = res.data[0].ShowPrice;
            this.tableData[this.rowIndexX].Qty = res.data[0].Qty;
            this.QtyTotalPrice(
              this.tableData[this.rowIndexX],
              this.tableData[this.rowIndexX].Qty
            );
          } else {
            this.tableData[this.rowIndexX].AQty = res.data[0].AQty;
            this.tableData[this.rowIndexX].ShowPrice = res.data[0].ShowPrice;
            this.tableData[this.rowIndexX].SalePrice = res.data[0].SalePrice;
            this.QtyTotalPrice(
              this.tableData[this.rowIndexX],
              this.tableData[this.rowIndexX].Qty
            );
          }
          // res.data[0].JobNumberData.forEach(item => {
          //   if (item.JobNumber == this.tableData[this.direction].JobNumber) {
          //     this.chooseBackbatchDialog(item);
          //   }
          // });
        })
        .catch((err) => {});
    },
    // 数量改变
    QtyTotalPrice(data, Qty_data) {
      if (this.$attrs.pargam.Model != "TakeStock") {
        if (Qty_data != undefined) {
          if (Number(data.Discount) != 1) {
            this.ObtainHeader.map((item) => {
              if (
                item.Key == "Discount" ||
                item.Key == "DiscountTotal" ||
                item.Key == "DiscountPrice"
              ) {
                if (item.Key == "Discount" && item.Show == false) {
                  tool.popMessage(
                    this,
                    "当前折扣不为 1 已自动显示折扣，折扣单价，折扣金额",
                    "warning"
                  );
                }
                item.Show = true;
              }
            });
            this.saveInfor();
          }
          if (Qty_data != 0 && Qty_data != "") {
            data.UnitData.map((item) => {
              if (item.Unit == data.Unit) {
                data.MQty = Number(item.Percent) * Number(Qty_data);
              }
            });
            if (data.SalePrice != 0 || data.SalePrice != "") {
              data.SaleTotal = tool.accMul(
                Number(Qty_data),
                Number(data.SalePrice),
                tool.getLocal("get_config").moneyPoint
              );
            }
          } else {
            data.SaleTotal = tool.accMul(
              Number(Qty_data),
              Number(data.SalePrice),
              tool.getLocal("get_config").moneyPoint
            );
          }
          data.Total = tool.accMul(
            Number(Qty_data),
            Number(data.ShowPrice),
            tool.getLocal("get_config").moneyPoint
          );
          // 折后单价=单价*折扣，
          data.DiscountPrice = tool.accMul(
            Number(data.Discount),
            Number(data.ShowPrice),
            tool.getLocal("get_config").moneyPoint
          );
          // 折后金额=折后单价*数量
          data.DiscountTotal = tool.accMul(
            Number(data.DiscountPrice),
            Number(Qty_data),
            tool.getLocal("get_config").moneyPoint
          );
          // 折后单价*(税率*0.01+1)=含税单价
          data.TaxPrice = tool.accMul(
            Number(data.DiscountPrice),
            Number(data.Tax * 0.01 + 1),
            tool.getLocal("get_config").moneyPoint
          );
          // 含税单价*数量=税价合计
          data.WithTaxTotal = tool.accMul(
            Number(data.TaxPrice),
            Number(Qty_data),
            tool.getLocal("get_config").moneyPoint
          );
        }
        data.MixQty = this.Reunitwithdata(
          data.UnitData,
          Qty_data,
          data.UnitName
        );

        setTimeout(() => {
          data.TaxTotal = (
            Number(data.WithTaxTotal) - Number(data.DiscountTotal)
          ).toFixed(tool.getLocal("get_config").moneyPoint);
        }, 100);
      } else if(this.$attrs.pargam.Model == 'Sale' &&  (tool.getLocal("companyid") == '1623291662597923' ||  tool.getLocal("companyid") == '1607053839898662') ){

        if (data.AQty != undefined) {
          if (data.APrice != "****" && data.ATotal != "****") {
            if (
              (Number(data.APrice) == 0 || Number(data.APrice) == "") &&
              (Number(data.AQty) != 0 || Number(data.AQty) != "")
            ) {
              data.ATotal = Number(tool.accMul(
                Number(data.AQty),
                Number(data.APrice),
                tool.getLocal("get_config").moneyPoint
              ));
            }
            if (
              (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
              (Number(data.AQty) != 0 || Number(data.AQty) != "")
            ) {
              data.ATotal =Number( tool.accMul(
                Number(data.AQty),
                Number(data.APrice),
                tool.getLocal("get_config").moneyPoint
              ));
            }
          }
        }


      }else {
        if (data.AQty != undefined) {
          if (data.APrice != "****" && data.ATotal != "****") {
            if (
              (Number(data.APrice) == 0 || Number(data.APrice) == "") &&
              (Number(data.AQty) != 0 || Number(data.AQty) != "")
            ) {
              data.ATotal = tool.accMul(
                Number(data.AQty),
                Number(data.APrice),
                tool.getLocal("get_config").moneyPoint
              );
            }
            if (
              (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
              (Number(data.AQty) != 0 || Number(data.AQty) != "")
            ) {
              data.ATotal = tool.accMul(
                Number(data.AQty),
                Number(data.APrice),
                tool.getLocal("get_config").moneyPoint
              );
            }
          }
        }
      }
    },
    change(val) {
      this.textname = val;
    },
    // 单价回填
    chooseBackUnitPrice(row) {
      this.tableData[this.direction].ShowPrice = row.Price;
      let data = this.tableData[this.direction];
      if (
        (data.Qty == 0 || data.Qty == "") &&
        data.ShowPrice != 0 &&
        data.ShowPrice != ""
      ) {
        data.Qty = (Number(data.Total) / Number(data.ShowPrice)).toFixed(2);
      } else {
        data.Total = tool.accMul(Number(data.Qty), Number(data.ShowPrice), 2);
        // data.Total = Number(data.Qty) * Number(data.ShowPrice);
      }
      this.QtyTotalPrice(this.tableData[this.direction], data.Qty);
    },
    // 单价点开
    Choicedj(row, rowIndex, index) {
      this.rowIndexX = rowIndex;
      this.indexy = index;
      this.searchData = row;
      this.tableUnitPrice = true;
    },
    // 选择资金
    ChoiceClick() {
      this.searchShow = true;
    },
    // 恢复默认
    restoreDefault(val) {
      this.ObtainHeader = val;
    },
    // 赠品
    selcetChange(val, data, index) {
      // data.Qty = 0;//数量
      data.ShowPrice = 0; //单价
      data.Total = 0; //金额
      data.Tax = 0; //税率
      data.TaxPrice = 0; //含税单价
      data.WithTaxTotal = 0; //含税金额
      data.TaxTotal = 0; //税额
      data.Discount = 1; //折扣
      data.DiscountPrice = 0; //折扣单价
      data.DiscountTotal = 0; //折扣金额
    },
    // 开启批号选择
    tablebatchb(data) {
      this.Goodsdata = data;
      this.tablebatchDialog = true;
      // 新增商品 要去数据回填
      this.fsafafadaf = 0;
    },
    // 表格数据回填
    chooseBack(data) {
      let object = data;
      function compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        };
      }
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          const element = object[key];
          if (this.$attrs.pargam.Model == "TakeStock") {
            if (element.CostType == 0) {
              object[key].APrice = element.ShowPrice;
            }
            object[key].AQty = 0;
            object[key].Qty = element.RQty;
          }
          object[key].KtypeId = this.$attrs.warehouseVal1.KtypeId;
          object[key].KtypeIdName = this.$attrs.warehouseVal1.FullName;
          object[key].UnitData = object[key].UnitData.sort(compare("Percent"));
        }
      }
      this.tableData.splice(this.rowIndexX, 1, ...object);
      this.$refs.xTable.recalculate();
      if (
        this.$attrs.pargam.Model != "SaleOrder" &&
        this.$attrs.pargam.Model != "BuyOrder"
      ) {
        for (let index = 0; index < object.length; index++) {
          const element = object[index];
          if (this.$attrs.pargam.Documenttype == 0 && element.CostType == 1) {
            this.Goodsdata = element;
            this.GoodstableData = object;
            if (!this.CombineBatch) {
              this.tablebatchDialogs = true;
            }
            return;
          }
        }
      }
    },
    // 商品名称
    doblurs(event, val, rowIndex, Key, name, row) {
      if (val === "") {
        event.srcElement.value = "";
        this.tableData[rowIndex][Key] = "";
      }
      if (val !== "") {
        this.tableData[rowIndex][Key] = this.FullNameName;
      }
    },
    doFocu(event, val, Key) {
      if (Key != undefined) {
        this.FullNameName = Number(Key);
      }
      event.currentTarget.select();
    },
    // 聚焦触发全输入框内容
    doFocus(event, val, rowIndex, Key, name, row) {
      this.FullNameName = name;
      if (val == "") {
        event.srcElement.value = "";
      }
      event.currentTarget.select();
    },
    // 拖动表格
    resizablechange({ $columnIndex, column }) {
      let datas = [];
      let jparams = {};
      this.ObtainHeader.map((tiem) => {
        if (tiem.Show != false) {
          datas.push(tiem);
        }
      });
      if (this.ImageUrlShow) {
        if ($columnIndex - 3 > 0 || $columnIndex == 3) {
          jparams = {
            user_id: tool.getLocal("userid"),
            session_id: tool.getLocal("sessionid"),
            Model: this.$attrs.pargam.Model,
            data: [
              {
                BaseNo: datas[$columnIndex - 3].BaseNo,
                Width: column.resizeWidth,
              },
            ],
          };
        }
      } else {
        if ($columnIndex - 2 > 0 || $columnIndex == 2) {
          jparams = {
            user_id: tool.getLocal("userid"),
            session_id: tool.getLocal("sessionid"),
            Model: this.$attrs.pargam.Model,
            data: [
              {
                BaseNo: datas[$columnIndex - 2].BaseNo,
                Width: column.resizeWidth,
              },
            ],
          };
        }
      }
      this.request
        .post("/index/Settings/modify_function_fields", {
          jparams: JSON.stringify(jparams),
        })
        .then((res) => {})
        .catch((err) => {});
    },
    // 修改 表头
    saveInfor(ObtainHeader) {
      // 重新为数组Reno赋值新的索引
      let configData = this.ObtainHeader.map((item, index) => {
        item.ReNo = index;
        return item;
      });
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Model: this.$attrs.pargam.Model, //从祖父页面传递过来的表示是什么页面，saleorder等
        data: configData,
      };
      this.request
        .post("/index/Settings/modify_function_fields", {
          jparams: JSON.stringify(params),
        })
        .then((res) => {})
        .catch((err) => {});
    },
    // 数量、单价、金额联动
    changeData(data, index, field, name, CostType, IsSerial) {
      if (this.$attrs.pargam.Model == 'Sale' &&  (tool.getLocal("companyid") == '1623291662597923' ||  tool.getLocal("companyid") == '1607053839898662') ) {
        // 判断输入的值是不是****
        if (this.FullNameName != "****" && name != "****") {
          // 判断当前值是否发生改变 如果发生改变就进行计算如果没发生改变就不变
          if (Number(this.FullNameName) != Number(name)) {
            setTimeout(() => {
              switch (field) {
                case "AQty":
                  if (data.AQty != undefined) {
                    if (data.APrice != "****" && data.ATotal != "****") {
                      if (
                        (Number(data.APrice) == 0 || Number(data.APrice) == "") &&
                        (Number(data.AQty) != 0 || Number(data.AQty) != "")
                      ) {
                        data.ATotal =  Number(tool.accMul(
                          Number(data.AQty),
                          Number(data.APrice),
                          tool.getLocal("get_config").moneyPoint
                        ));
                      }
                      if (
                        (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
                        (Number(data.AQty) != 0 || Number(data.AQty) != "")
                      ) {
                        data.ATotal =  Number(tool.accMul(
                          Number(data.AQty),
                          Number(data.APrice),
                          tool.getLocal("get_config").moneyPoint
                        ));
                      }
                    }
                  }
                  break;
                case "ATotal":
                  if (data.ATotal != undefined) {
                    if (
                      (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
                      (Number(data.AQty) != 0 || Number(data.AQty) != "")
                    ) {
                      data.APrice =  Number(this.aseggfg(
                        Number(data.ATotal),
                        Number(data.AQty),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      // data.APrice = Number(data.ATotal) / Number(data.AQty);
                    }
                    if (
                      (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
                      (Number(data.AQty) == 0 || Number(data.AQty) == "")
                    ) {
                      data.AQty =  Number(this.aseggfg(
                        Number(data.ATotal),
                        Number(data.APrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                  }
                  break;
                case "APrice":
                  if (data.APrice != undefined) {
                    if (
                      (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
                      (Number(data.AQty) == 0 || Number(data.AQty) == "")
                    ) {
                      data.AQty =  Number(this.aseggfg(
                        Number(data.APrice),
                        Number(data.ATotal),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    if (
                      (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
                      (Number(data.AQty) != 0 || Number(data.AQty) != "")
                    ) {
                      data.ATotal =  Number(tool.accMul(
                        Number(data.AQty),
                        Number(data.APrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    if (
                      (Number(data.ATotal) == 0 || Number(data.ATotal) == "") &&
                      (Number(data.AQty) != 0 || Number(data.AQty) != "")
                    ) {
                      data.ATotal =  Number(tool.accMul(
                        Number(data.AQty),
                        Number(data.APrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                  }
                  break;
                // 数量
                case "Qty":
                  if (data.Qty != undefined && Number(data.Qty) != 0) {
                    if (Number(data.Discount) != 1) {
                      this.ObtainHeader.map((item) => {
                        if (
                          item.Key == "Discount" ||
                          item.Key == "DiscountTotal" ||
                          item.Key == "DiscountPrice"
                        ) {
                          if (item.Key == "Discount" && item.Show == false) {
                            tool.popMessage(
                              this,
                              "当前折扣不为 1 已自动显示折扣，折扣单价，折扣金额",
                              "warning"
                            );
                          }
                          item.Show = true;
                        }
                      });
                    }
                    if (data.Qty != 0 && data.Qty != "") {
                      data.UnitData.map((item) => {
                        if (item.Unit == data.Unit) {
                          data.MQty =  Number((Number(item.Percent) * Number(data.Qty)));
                        }
                      });
                      if (data.ShowPrice != 0 || data.ShowPrice != "") {
                        data.SaleTotal =  Number(tool.accMul(
                          Number(data.Qty),
                          Number(data.SalePrice),
                          tool.getLocal("get_config").moneyPoint
                        ));
                      }
                      data.Total =  Number(tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    } else {
                      data.SaleTotal =  Number(tool.accMul(
                        Number(data.Qty),
                        Number(data.SalePrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    if (Number(data.Discount) != 0) {
                      // 折后金额
                      data.DiscountTotal =  Number((
                        Number(data.Qty) *
                        Number(data.ShowPrice) *
                        Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                      // 折后单价
                      data.DiscountPrice =  Number(tool.accMul(
                        Number(data.ShowPrice),
                        Number(data.Discount),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      // 折后单价*(税率*0.01+1)=含税单价
                      data.TaxPrice =  Number(tool.accMul(
                        Number(data.DiscountPrice),
                        Number(data.Tax * 0.01 + 1),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      // 含税单价*数量=税价合计
                      data.WithTaxTotal = Number( tool.accMul(
                        Number(data.TaxPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    // 零售金额  = 数量 * 零售价格
                    data.SaleTotal = Number(tool.accMul(
                      Number(data.Qty),
                      Number(data.SalePrice),
                      tool.getLocal("get_config").moneyPoint
                    ));
                  }
                  setTimeout(() => {
                    data.MixQty = this.Reunitwithdata(
                      data.UnitData,
                      name,
                      data.UnitName
                    );
                  }, 200);
                  break;
                // 单价
                case "ShowPrice":
                  if (data.ShowPrice != undefined) {
                    if (
                      (data.Qty == 0 || data.Qty == "") &&
                      data.ShowPrice != 0 &&
                      data.ShowPrice != ""
                    ) {
                      if (!IsSerial) {
                        data.Qty =  Number((
                          Number(data.Total) / Number(data.ShowPrice)
                        ).toFixed(tool.getLocal("get_config").moneyPoint));
                      }
                    } else {
                      data.Total =  Number(tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      // data.Total = Number(data.Qty) * Number(data.ShowPrice);
                    }
                    // 折后单价=单价*折扣，
                    data.DiscountPrice =  Number(tool.accMul(
                      Number(data.Discount),
                      Number(data.ShowPrice),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    // 折后金额=折后单价*数量
                    data.DiscountTotal =  Number(tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    // 折后单价*(税率*0.01+1)=含税单价
                    data.TaxPrice = Number( tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax * 0.01 + 1),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    // 含税单价*数量=税价合计
                    data.WithTaxTotal =  Number(tool.accMul(
                      Number(data.TaxPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    ));
                  }
                  break;
                // 金额
                case "Total":
                  if (data.Total != undefined) {
                    if (
                      (data.Qty == 0 || data.Qty == "") &&
                      data.ShowPrice != 0 &&
                      data.ShowPrice != ""
                    ) {
                      if (!IsSerial) {
                        data.Qty =  Number((
                          Number(data.Total) / Number(data.ShowPrice)
                        ).toFixed(tool.getLocal("get_config").moneyPoint));
                      }
                    }
                    if (data.Qty != 0 && data.Qty != "") {
                      data.ShowPrice =  Number((
                        Number(data.Total) / Number(data.Qty)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                    }
                    data.DiscountPrice =  Number(tool.accMul(
                      Number(data.Discount),
                      Number(data.ShowPrice),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    data.DiscountTotal =  Number(tool.accMul(
                      Number(data.Discount),
                      Number(data.Total),
                      tool.getLocal("get_config").moneyPoint
                    ));
                  }
                  break;
                // 折扣
                case "Discount":
                  // 折后金额
                  data.DiscountTotal = Number( (
                    Number(data.Qty) *
                    Number(data.ShowPrice) *
                    Number(data.Discount)
                  ).toFixed(tool.getLocal("get_config").moneyPoint));
                  // 折后单价
                  data.DiscountPrice = Number( tool.accMul(
                    Number(data.ShowPrice),
                    Number(data.Discount),
                    tool.getLocal("get_config").moneyPoint
                  ));
                  // 折后单价*(税率*0.01+1)=含税单价
                  data.TaxPrice =  Number(tool.accMul(
                    Number(data.DiscountPrice),
                    Number(data.Tax * 0.01 + 1),
                    tool.getLocal("get_config").moneyPoint
                  ));
                  // 含税单价*数量=税价合计
                  data.WithTaxTotal =  Number(tool.accMul(
                    Number(data.TaxPrice),
                    Number(data.Qty),
                    tool.getLocal("get_config").moneyPoint
                  ));
                  break;
                // 折后单价
                case "DiscountPrice":
                  if (data.ShowPrice == "" || data.ShowPrice == 0) {
                    tool.popMessage(this, "必须录入单价", "warning");
                  } else {
                    // if (
                    //   data.WithTaxTotal != "****" &&
                    //   data.TaxPrice != "****" &&
                    //   data.DiscountTotal != "****"
                    // ) {
                    // 不知道单价  知道折扣  输入折扣单价  算出单价  折扣单价/折扣 = 单价
                    if (data.ShowPrice == "****") {
                      data.ShowPrice = Number( (
                        Number(data.DiscountPrice) / Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                      data.Total =  Number(tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    // 折扣=折后单价/单价
                    data.Discount =  Number((
                      Number(data.DiscountPrice) / Number(data.ShowPrice)
                    ).toFixed(tool.getLocal("get_config").moneyPoint));
                    // 折后金额=数量*折后单价
                    data.DiscountTotal =  Number(tool.accMul(
                      Number(data.Qty),
                      Number(data.DiscountPrice),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    // 折后单价*(税率*0.01+1)=含税单价
                    data.TaxPrice =  Number(tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax * 0.01 + 1),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    // 含税单价*数量=税价合计
                    data.WithTaxTotal =  Number(tool.accMul(
                      Number(data.TaxPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    ));
                  }
                  // }
                  break;
                // 折后金额
                case "DiscountTotal":
                  if (data.ShowPrice == "" || data.ShowPrice == 0) {
                    tool.popMessage(this, "必须录入单价", "warning");
                  } else {
                    // if (
                    //   data.WithTaxTotal != "****" &&
                    //   data.TaxPrice != "****" &&
                    //   data.DiscountPrice != "****" &&
                    //   data.Total != "****"
                    // ) {
                    // 知道折扣   输入折后金额 得出 金额   折后/折扣 = 金额
                    if (data.Total == "****") {
                      data.Total =  Number(this.aseggfg(
                        Number(data.DiscountTotal),
                        Number(data.Discount),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      data.ShowPrice =  Number((
                        Number(data.Total) / Number(data.Qty)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                    }
  
                    if (data.Total != "****") {
                      // 折扣=折后金额/金额
                      data.Discount =  Number(this.aseggfg(
                        Number(data.DiscountTotal),
                        Number(data.Total),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    // 折后单价=折后金额/数量
                    data.DiscountPrice =  Number(this.aseggfg(
                      Number(data.DiscountTotal),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    // 折后单价*(税率*0.01+1)=含税单价
                    data.TaxPrice =  Number(tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax * 0.01 + 1),
                      tool.getLocal("get_config").moneyPoint
                    ));
                    if (data.TaxPrice != "****") {
                      // 含税单价*数量=税价合计
                      data.WithTaxTotal = Number( tool.accMul(
                        Number(data.TaxPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                    // }
                  }
                  break;
                // 税率
                case "Tax":
                  // 录入税率，单价，数量：
                  // 折后单价=单价*折扣，折后金额=折后单价*数量
                  // 折后单价*(税率*0.01+1)=含税单价，含税单价*数量=税价合计
                  if (data.TaxPrice != "****" && data.DiscountPrice != "****") {
                    data.TaxPrice =  Number(tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax) * 0.01 + 1,
                      tool.getLocal("get_config").moneyPoint
                    ));
                    data.WithTaxTotal =  Number(tool.accMul(
                      Number(data.TaxPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    ));
                  }
                  break;
                // 含税单价
                case "TaxPrice":
                  if (data.Tax == "" || data.Tax == 0) {
                    tool.popMessage(this, "必须录入税率", "warning");
                  } else {
                    if (
                      (Number(data.ShowPrice) != 0 || Number(data.ShowPrice)) !=
                        "" ||
                      (Number(data.Total) != 0 || Number(data.Total)) != "" ||
                      Number(data.Qty) != 0 ||
                      Number(data.Qty) != ""
                    ) {
                      if (data.WithTaxTotal == "****") {
                        data.WithTaxTotal =  Number(tool.accMul(
                          Number(data.TaxPrice),
                          Number(data.Qty),
                          tool.getLocal("get_config").moneyPoint
                        ));
                      }
                      // 折后单价=含税单价/（税率*0.01+1）
                      data.DiscountPrice =  Number((
                        Number(data.TaxPrice) /
                        (Number(data.Tax) * 0.01 + 1)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                      // tool.getLocal("get_config").moneyPoint;
                      // 税价合计=含税单价*数量，
  
                      // 折后金额=折扣单价*数量，
                      data.DiscountTotal =  Number(tool.accMul(
                        Number(data.DiscountPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      // 单价=折后单价/折扣，
                      data.ShowPrice =  Number((
                        Number(data.DiscountPrice) / Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                      // 金额=数量*单价
                      data.Total =  Number(tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                  }
                  break;
                // 价税合计
                case "WithTaxTotal":
                  if (data.Tax == "" || data.Tax == 0) {
                    tool.popMessage(this, "必须录入税率", "warning");
                  } else {
                    if (
                      (Number(data.ShowPrice) != 0 || Number(data.ShowPrice)) !=
                        "" ||
                      (Number(data.Total) != 0 || Number(data.Total)) != "" ||
                      Number(data.Qty) != 0 ||
                      Number(data.Qty) != ""
                    ) {
                      if ((data.TaxPrice = "****")) {
                        // 含税单价=价税合计/数量，
                        data.TaxPrice =  Number((
                          Number(data.WithTaxTotal) / Number(data.Qty)
                        ).toFixed(tool.getLocal("get_config").moneyPoint));
                      }
                      // 折后单价=含税单价/（税率*0.01+1）
                      data.DiscountPrice =  Number((
                        Number(data.TaxPrice) /
                        (Number(data.Tax) * 0.01 + 1)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                      // 折后金额=折扣单价*数量，
                      data.DiscountTotal =  Number(tool.accMul(
                        Number(data.DiscountPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      ));
                      // 单价=折后单价/折扣，
                      data.ShowPrice =  Number((
                        Number(data.DiscountPrice) / Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint));
                      // 金额=数量*单价
                      data.Total =  Number(tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      ));
                    }
                  }
                  break;
                default:
                  break;
              }
              if (this.$attrs.pargam.Model != "TakeStock") {
                setTimeout(() => {
                  if (
                    data.DiscountTotal != "****" &&
                    data.WithTaxTotal != "****"
                  ) {
                    data.TaxTotal =  Number((
                      Number(data.WithTaxTotal) - Number(data.DiscountTotal)
                    ).toFixed(tool.getLocal("get_config").moneyPoint));
                  }
                }, 200);
              }
  
              if (
                data.Tax == "" ||
                data.Tax == undefined ||
                Number(data.Tax) == 0 ||
                Number(data.ShowPrice) == 0
              ) {
                if (
                  data.DiscountPrice != "****" &&
                  data.DiscountTotal != "****"
                ) {
                }
                // 税率默认为空：折后单价=含税单价；折后金额=含税金额
                data.TaxPrice = data.DiscountPrice;
                data.WithTaxTotal = data.DiscountTotal;
              }
              if (Number(data[field]) != 0) {
                if (data[field] != "****") {
                  data[field] = Number( Number(
                    data[field]
                  ).toFixed(tool.getLocal("get_config").moneyPoint));
                }
              }
            }, 10);
            // }
          }
        }
      }else{
        // 判断输入的值是不是****
        if (this.FullNameName != "****" && name != "****") {
          // 判断当前值是否发生改变 如果发生改变就进行计算如果没发生改变就不变
          if (Number(this.FullNameName) != Number(name)) {
            setTimeout(() => {
              switch (field) {
                case "AQty":
                  if (data.AQty != undefined) {
                    if (data.APrice != "****" && data.ATotal != "****") {
                      if (
                        (Number(data.APrice) == 0 || Number(data.APrice) == "") &&
                        (Number(data.AQty) != 0 || Number(data.AQty) != "")
                      ) {
                        data.ATotal = tool.accMul(
                          Number(data.AQty),
                          Number(data.APrice),
                          tool.getLocal("get_config").moneyPoint
                        );
                      }
                      if (
                        (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
                        (Number(data.AQty) != 0 || Number(data.AQty) != "")
                      ) {
                        data.ATotal = tool.accMul(
                          Number(data.AQty),
                          Number(data.APrice),
                          tool.getLocal("get_config").moneyPoint
                        );
                      }
                    }
                  }
                  break;
                case "ATotal":
                  if (data.ATotal != undefined) {
                    if (
                      (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
                      (Number(data.AQty) != 0 || Number(data.AQty) != "")
                    ) {
                      data.APrice = this.aseggfg(
                        Number(data.ATotal),
                        Number(data.AQty),
                        tool.getLocal("get_config").moneyPoint
                      );
                      // data.APrice = Number(data.ATotal) / Number(data.AQty);
                    }
                    if (
                      (Number(data.APrice) != 0 || Number(data.APrice) != "") &&
                      (Number(data.AQty) == 0 || Number(data.AQty) == "")
                    ) {
                      data.AQty = this.aseggfg(
                        Number(data.ATotal),
                        Number(data.APrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                  }
                  break;
                case "APrice":
                  if (data.APrice != undefined) {
                    if (
                      (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
                      (Number(data.AQty) == 0 || Number(data.AQty) == "")
                    ) {
                      data.AQty = this.aseggfg(
                        Number(data.APrice),
                        Number(data.ATotal),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    if (
                      (Number(data.ATotal) != 0 || Number(data.ATotal) != "") &&
                      (Number(data.AQty) != 0 || Number(data.AQty) != "")
                    ) {
                      data.ATotal = tool.accMul(
                        Number(data.AQty),
                        Number(data.APrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    if (
                      (Number(data.ATotal) == 0 || Number(data.ATotal) == "") &&
                      (Number(data.AQty) != 0 || Number(data.AQty) != "")
                    ) {
                      data.ATotal = tool.accMul(
                        Number(data.AQty),
                        Number(data.APrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                  }
                  break;
                // 数量
                case "Qty":
                  if (data.Qty != undefined && Number(data.Qty) != 0) {
                    if (Number(data.Discount) != 1) {
                      this.ObtainHeader.map((item) => {
                        if (
                          item.Key == "Discount" ||
                          item.Key == "DiscountTotal" ||
                          item.Key == "DiscountPrice"
                        ) {
                          if (item.Key == "Discount" && item.Show == false) {
                            tool.popMessage(
                              this,
                              "当前折扣不为 1 已自动显示折扣，折扣单价，折扣金额",
                              "warning"
                            );
                          }
                          item.Show = true;
                        }
                      });
                    }
                    if (data.Qty != 0 && data.Qty != "") {
                      data.UnitData.map((item) => {
                        if (item.Unit == data.Unit) {
                          data.MQty = Number(item.Percent) * Number(data.Qty);
                        }
                      });
                      if (data.ShowPrice != 0 || data.ShowPrice != "") {
                        data.SaleTotal = tool.accMul(
                          Number(data.Qty),
                          Number(data.SalePrice),
                          tool.getLocal("get_config").moneyPoint
                        );
                      }
                      data.Total = tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    } else {
                      data.SaleTotal = tool.accMul(
                        Number(data.Qty),
                        Number(data.SalePrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    if (Number(data.Discount) != 0) {
                      // 折后金额
                      data.DiscountTotal = (
                        Number(data.Qty) *
                        Number(data.ShowPrice) *
                        Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                      // 折后单价
                      data.DiscountPrice = tool.accMul(
                        Number(data.ShowPrice),
                        Number(data.Discount),
                        tool.getLocal("get_config").moneyPoint
                      );
                      // 折后单价*(税率*0.01+1)=含税单价
                      data.TaxPrice = tool.accMul(
                        Number(data.DiscountPrice),
                        Number(data.Tax * 0.01 + 1),
                        tool.getLocal("get_config").moneyPoint
                      );
                      // 含税单价*数量=税价合计
                      data.WithTaxTotal = tool.accMul(
                        Number(data.TaxPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    // 零售金额  = 数量 * 零售价格
                    data.SaleTotal = tool.accMul(
                      Number(data.Qty),
                      Number(data.SalePrice),
                      tool.getLocal("get_config").moneyPoint
                    );
                  }
                  setTimeout(() => {
                    data.MixQty = this.Reunitwithdata(
                      data.UnitData,
                      name,
                      data.UnitName
                    );
                  }, 200);
                  break;
                // 单价
                case "ShowPrice":
                  if (data.ShowPrice != undefined) {
                    if (
                      (data.Qty == 0 || data.Qty == "") &&
                      data.ShowPrice != 0 &&
                      data.ShowPrice != ""
                    ) {
                      if (!IsSerial) {
                        data.Qty = (
                          Number(data.Total) / Number(data.ShowPrice)
                        ).toFixed(tool.getLocal("get_config").moneyPoint);
                      }
                    } else {
                      data.Total = tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                      // data.Total = Number(data.Qty) * Number(data.ShowPrice);
                    }
                    // 折后单价=单价*折扣，
                    data.DiscountPrice = tool.accMul(
                      Number(data.Discount),
                      Number(data.ShowPrice),
                      tool.getLocal("get_config").moneyPoint
                    );
                    // 折后金额=折后单价*数量
                    data.DiscountTotal = tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    );
                    // 折后单价*(税率*0.01+1)=含税单价
                    data.TaxPrice = tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax * 0.01 + 1),
                      tool.getLocal("get_config").moneyPoint
                    );
                    // 含税单价*数量=税价合计
                    data.WithTaxTotal = tool.accMul(
                      Number(data.TaxPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    );
                  }
                  break;
                // 金额
                case "Total":
                  if (data.Total != undefined) {
                    if (
                      (data.Qty == 0 || data.Qty == "") &&
                      data.ShowPrice != 0 &&
                      data.ShowPrice != ""
                    ) {
                      if (!IsSerial) {
                        data.Qty = (
                          Number(data.Total) / Number(data.ShowPrice)
                        ).toFixed(tool.getLocal("get_config").moneyPoint);
                      }
                    }
                    if (data.Qty != 0 && data.Qty != "") {
                      data.ShowPrice = (
                        Number(data.Total) / Number(data.Qty)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                    }
                    data.DiscountPrice = tool.accMul(
                      Number(data.Discount),
                      Number(data.ShowPrice),
                      tool.getLocal("get_config").moneyPoint
                    );
                    data.DiscountTotal = tool.accMul(
                      Number(data.Discount),
                      Number(data.Total),
                      tool.getLocal("get_config").moneyPoint
                    );
                  }
                  break;
                // 折扣
                case "Discount":
                  // 折后金额
                  data.DiscountTotal = (
                    Number(data.Qty) *
                    Number(data.ShowPrice) *
                    Number(data.Discount)
                  ).toFixed(tool.getLocal("get_config").moneyPoint);
                  // 折后单价
                  data.DiscountPrice = tool.accMul(
                    Number(data.ShowPrice),
                    Number(data.Discount),
                    tool.getLocal("get_config").moneyPoint
                  );
                  // 折后单价*(税率*0.01+1)=含税单价
                  data.TaxPrice = tool.accMul(
                    Number(data.DiscountPrice),
                    Number(data.Tax * 0.01 + 1),
                    tool.getLocal("get_config").moneyPoint
                  );
                  // 含税单价*数量=税价合计
                  data.WithTaxTotal = tool.accMul(
                    Number(data.TaxPrice),
                    Number(data.Qty),
                    tool.getLocal("get_config").moneyPoint
                  );
                  break;
                // 折后单价
                case "DiscountPrice":
                  if (data.ShowPrice == "" || data.ShowPrice == 0) {
                    tool.popMessage(this, "必须录入单价", "warning");
                  } else {
                    // if (
                    //   data.WithTaxTotal != "****" &&
                    //   data.TaxPrice != "****" &&
                    //   data.DiscountTotal != "****"
                    // ) {
                    // 不知道单价  知道折扣  输入折扣单价  算出单价  折扣单价/折扣 = 单价
                    if (data.ShowPrice == "****") {
                      data.ShowPrice = (
                        Number(data.DiscountPrice) / Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                      data.Total = tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    // 折扣=折后单价/单价
                    data.Discount = (
                      Number(data.DiscountPrice) / Number(data.ShowPrice)
                    ).toFixed(tool.getLocal("get_config").moneyPoint);
                    // 折后金额=数量*折后单价
                    data.DiscountTotal = tool.accMul(
                      Number(data.Qty),
                      Number(data.DiscountPrice),
                      tool.getLocal("get_config").moneyPoint
                    );
                    // 折后单价*(税率*0.01+1)=含税单价
                    data.TaxPrice = tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax * 0.01 + 1),
                      tool.getLocal("get_config").moneyPoint
                    );
                    // 含税单价*数量=税价合计
                    data.WithTaxTotal = tool.accMul(
                      Number(data.TaxPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    );
                  }
                  // }
                  break;
                // 折后金额
                case "DiscountTotal":
                  if (data.ShowPrice == "" || data.ShowPrice == 0) {
                    tool.popMessage(this, "必须录入单价", "warning");
                  } else {
                    // if (
                    //   data.WithTaxTotal != "****" &&
                    //   data.TaxPrice != "****" &&
                    //   data.DiscountPrice != "****" &&
                    //   data.Total != "****"
                    // ) {
                    // 知道折扣   输入折后金额 得出 金额   折后/折扣 = 金额
                    if (data.Total == "****") {
                      data.Total = this.aseggfg(
                        Number(data.DiscountTotal),
                        Number(data.Discount),
                        tool.getLocal("get_config").moneyPoint
                      );
                      data.ShowPrice = (
                        Number(data.Total) / Number(data.Qty)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                    }
  
                    if (data.Total != "****") {
                      // 折扣=折后金额/金额
                      data.Discount = this.aseggfg(
                        Number(data.DiscountTotal),
                        Number(data.Total),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    // 折后单价=折后金额/数量
                    data.DiscountPrice = this.aseggfg(
                      Number(data.DiscountTotal),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    );
                    // 折后单价*(税率*0.01+1)=含税单价
                    data.TaxPrice = tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax * 0.01 + 1),
                      tool.getLocal("get_config").moneyPoint
                    );
                    if (data.TaxPrice != "****") {
                      // 含税单价*数量=税价合计
                      data.WithTaxTotal = tool.accMul(
                        Number(data.TaxPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                    // }
                  }
                  break;
                // 税率
                case "Tax":
                  // 录入税率，单价，数量：
                  // 折后单价=单价*折扣，折后金额=折后单价*数量
                  // 折后单价*(税率*0.01+1)=含税单价，含税单价*数量=税价合计
                  if (data.TaxPrice != "****" && data.DiscountPrice != "****") {
                    data.TaxPrice = tool.accMul(
                      Number(data.DiscountPrice),
                      Number(data.Tax) * 0.01 + 1,
                      tool.getLocal("get_config").moneyPoint
                    );
                    data.WithTaxTotal = tool.accMul(
                      Number(data.TaxPrice),
                      Number(data.Qty),
                      tool.getLocal("get_config").moneyPoint
                    );
                  }
                  break;
                // 含税单价
                case "TaxPrice":
                  if (data.Tax == "" || data.Tax == 0) {
                    tool.popMessage(this, "必须录入税率", "warning");
                  } else {
                    if (
                      (Number(data.ShowPrice) != 0 || Number(data.ShowPrice)) !=
                        "" ||
                      (Number(data.Total) != 0 || Number(data.Total)) != "" ||
                      Number(data.Qty) != 0 ||
                      Number(data.Qty) != ""
                    ) {
                      if (data.WithTaxTotal == "****") {
                        data.WithTaxTotal = tool.accMul(
                          Number(data.TaxPrice),
                          Number(data.Qty),
                          tool.getLocal("get_config").moneyPoint
                        );
                      }
                      // 折后单价=含税单价/（税率*0.01+1）
                      data.DiscountPrice = (
                        Number(data.TaxPrice) /
                        (Number(data.Tax) * 0.01 + 1)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                      // tool.getLocal("get_config").moneyPoint;
                      // 税价合计=含税单价*数量，
  
                      // 折后金额=折扣单价*数量，
                      data.DiscountTotal = tool.accMul(
                        Number(data.DiscountPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      );
                      // 单价=折后单价/折扣，
                      data.ShowPrice = (
                        Number(data.DiscountPrice) / Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                      // 金额=数量*单价
                      data.Total = tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                  }
                  break;
                // 价税合计
                case "WithTaxTotal":
                  if (data.Tax == "" || data.Tax == 0) {
                    tool.popMessage(this, "必须录入税率", "warning");
                  } else {
                    if (
                      (Number(data.ShowPrice) != 0 || Number(data.ShowPrice)) !=
                        "" ||
                      (Number(data.Total) != 0 || Number(data.Total)) != "" ||
                      Number(data.Qty) != 0 ||
                      Number(data.Qty) != ""
                    ) {
                      if ((data.TaxPrice = "****")) {
                        // 含税单价=价税合计/数量，
                        data.TaxPrice = (
                          Number(data.WithTaxTotal) / Number(data.Qty)
                        ).toFixed(tool.getLocal("get_config").moneyPoint);
                      }
                      // 折后单价=含税单价/（税率*0.01+1）
                      data.DiscountPrice = (
                        Number(data.TaxPrice) /
                        (Number(data.Tax) * 0.01 + 1)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                      // 折后金额=折扣单价*数量，
                      data.DiscountTotal = tool.accMul(
                        Number(data.DiscountPrice),
                        Number(data.Qty),
                        tool.getLocal("get_config").moneyPoint
                      );
                      // 单价=折后单价/折扣，
                      data.ShowPrice = (
                        Number(data.DiscountPrice) / Number(data.Discount)
                      ).toFixed(tool.getLocal("get_config").moneyPoint);
                      // 金额=数量*单价
                      data.Total = tool.accMul(
                        Number(data.Qty),
                        Number(data.ShowPrice),
                        tool.getLocal("get_config").moneyPoint
                      );
                    }
                  }
                  break;
                default:
                  break;
              }
              if (this.$attrs.pargam.Model != "TakeStock") {
                setTimeout(() => {
                  if (
                    data.DiscountTotal != "****" &&
                    data.WithTaxTotal != "****"
                  ) {
                    data.TaxTotal = (
                      Number(data.WithTaxTotal) - Number(data.DiscountTotal)
                    ).toFixed(tool.getLocal("get_config").moneyPoint);
                  }
                }, 200);
              }
  
              if (
                data.Tax == "" ||
                data.Tax == undefined ||
                Number(data.Tax) == 0 ||
                Number(data.ShowPrice) == 0
              ) {
                if (
                  data.DiscountPrice != "****" &&
                  data.DiscountTotal != "****"
                ) {
                }
                // 税率默认为空：折后单价=含税单价；折后金额=含税金额
                data.TaxPrice = data.DiscountPrice;
                data.WithTaxTotal = data.DiscountTotal;
              }
              if (Number(data[field]) != 0) {
                if (data[field] != "****") {
                  data[field] = Number(
                    // data[field].replace(/\b(0+)/gi, "")
                    data[field]
                  ).toFixed(tool.getLocal("get_config").moneyPoint);
                }
              }
            }, 10);
            // }
          }
          // if (data[field] != "****") {
          //   data[field] = Number(data[field]).toFixed(
          //     tool.getLocal("get_config").moneyPoint
          //   );
          // }
        }
      }
    },
    aseggfg(arg1, arg2, fix) {
      if (!parseInt(fix) == fix) {
        return;
      }
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      if (m > fix) {
        return (
          Math.round(
            (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
              Math.pow(10, m - fix)
          ) * Math.pow(10, fix)
        );
      } else if (m <= fix) {
        return (
          (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
          Math.pow(10, m)
        ).toFixed(fix);
      } else {
        return arg1 / arg2; //.toFixed(fix);
      }
    },
    valuename(arg1, arg2, fix) {
      if (!parseInt(fix) == fix) {
        return;
      }
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      if (m > fix) {
        return (
          Math.round(
            (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
              Math.pow(10, m - fix)
          ) * Math.pow(10, fix)
        );
      } else if (m <= fix) {
        return (
          (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
          Math.pow(10, m)
        ).toFixed(fix);
      } else {
        return arg1 / arg2; //.toFixed(fix);
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (this.footerNames.includes(column.property)) {
            return this.sum(data, column.property); //this.$attrs.footerMet[column.property]; //this.$utils.sum(data, column.property);
          }
          // return null;
        }),
      ];
    },
    sum(data, e) {
      let d = 0;
      data.map((item) => {
        if (item.PtypeId != "") {
          if (item[e] == "****") {
            d = "****";
          } else if (item[e] == null) {
            // d = Number(0).toFixed(tool.getLocal("get_config").moneyPoint);
          } else {
            d += Number(item[e]);
          }
        }
      });
      if (d != "****") {
         if (this.$attrs.pargam.Model == 'Sale' &&  (tool.getLocal("companyid") == '1623291662597923' ||  tool.getLocal("companyid") == '1607053839898662') ) {
           return Number(Number(d).toFixed(tool.getLocal("get_config").moneyPoint));
        }else{
          return Number(d).toFixed(tool.getLocal("get_config").moneyPoint);;
        }
      } else return d;
    },
    // 新增某一行
    addRow(index) {
      this.$emit("addback", index);
      setTimeout(() => {
        this.$refs.xTable.setCurrentRow(this.tableData[index - 1]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }, 10);
    },
    // 移除某一行
    deleteRow(index) {
      this.$emit("deleteRow", index);
      setTimeout(() => {
        this.$refs.xTable.setCurrentRow(this.tableData[index - 1]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }, 10);
    },
    // 获取第一个输入框 第一行高亮
    childAction(ind) {
      indexid = 0;
      this.indexid = 0;
      this.direction = 0;
      this.Duplicateremoval(this.$refs.Qtyfocus)[0].focus();
      this.$refs.xTable.setCurrentRow(this.tableData[0]);
      this.focusinputa = this.Duplicateremoval(this.$refs.Qtyfocus)[0].id;
    },
    // 循环去重
    Duplicateremoval(arr) {
      var ars = arr;
      ars.map((item, i) => {
        if (item.$refs != undefined) {
          ars.splice(i, 0, item.$refs.input);
        }
      });
      for (let i = 0; i < ars.length; i++) {
        for (var j = i + 1; j < ars.length; j++) {
          if (ars[i].id == ars[j].id) {
            ars.splice(j, 1);
            j--;
          }
        }
      }
      return ars;
    },
    // 滚动条 上移
    highlightcurren(dire) {
      if (dire - 1 != -1) {
        this.direction = dire - 1;
        this.$refs.xTable.setCurrentRow(this.tableData[this.direction]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 滚动条 下移
    highlightcurrens(dire) {
      if (dire + 1 != this.tableData.length) {
        this.direction = dire + 1;
        this.$refs.xTable.setCurrentRow(this.tableData[this.direction]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 双击单元格
    celldblclick(
      { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, cell },
      event
    ) {},
    distinctObj(numberArr, ind) {
      let obj = "";
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    // 点击单元格
    cellclick({ row, $rowIndex, columnIndex, column }) {
      console.log(column.property);
      if (row.FullName == "" && column.property != "FullName") {
      } else {
        this.direction = $rowIndex;
        this.rowIndexX = $rowIndex;
        this.indexy = columnIndex - 1;
        if (
          (event.target.id == "" || event.target.id == undefined) &&
          column.property != "ShowPrice"
        ) {
          this.focusinputa = `x_${$rowIndex}_y_0`;
        } else {
          this.focusinputa = event.target.id;
        }
        this.$refs.xTable.refreshScroll();
      }
    },
    // 获取数组中指定元素的位置
    Arrlength(arr, dst, val = 1) {
      if (val == 0) {
        var i = 0;
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (element == dst) {
            i = index;
            return i;
          }
        }
        return false;
      } else {
        var i = 0;
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (element.id == dst) {
            i = index;
            return i;
          }
        }
        return false;
      }
    },
    // 上
    UpArrow(row, rowIndex, index, FirstOne, LastOne, length) {
      return;
      this.highlightcurren(rowIndex);
      rowIndex = rowIndex - 1;
      if (
        this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_${index}`) !==
        false
      ) {
        this.distinctObj(
          this.$refs.Qtyfocus,
          `x_${rowIndex}_y_${index}`
        ).focus();
        this.focusinputa = `x_${rowIndex}_y_${index}`;
      } else {
        if (
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_0`) !== false
        ) {
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_0`).focus();
          this.focusinputa = `x_${rowIndex}_y_0`;
        }
      }
    },
    // 下
    DwArrow(row, rowIndex, index, FirstOne, LastOne, length) {
      return;
      this.highlightcurrens(rowIndex);
      rowIndex = rowIndex + 1;
      if (
        this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_${index}`) !==
        false
      ) {
        this.distinctObj(
          this.$refs.Qtyfocus,
          `x_${rowIndex}_y_${index}`
        ).focus();
        this.focusinputa = `x_${rowIndex}_y_${index}`;
      } else {
        if (
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_0`) !== false
        ) {
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_0`).focus();
          this.focusinputa = `x_${rowIndex}_y_0`;
        }
      }
    },
    // 左
    LeftArrow(row, rowIndex, index, FirstOne, LastOne, length) {},
    // 右
    RightArrow(row, rowIndex, index, FirstOne, LastOne, length) {},
    // 回车
    EnterArrow(row, rowIndex, index, FirstOne, LastOne, length, key, name) {
      if (row.PtypeId == "" && index == 0) {
        this.searchShow = true;
        // } else if (key == "ShowPrice" && row.SalePrice == "") {
      } else {
        for (let i = index + 1; i < this.Obtain.length; i++) {
          if (
            this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_${i}`) !==
            false
          ) {
            this.distinctObj(
              this.$refs.Qtyfocus,
              `x_${rowIndex}_y_${i}`
            ).focus();
            this.focusinputa = `x_${rowIndex}_y_${i}`;
            return;
          }
          if (i + 1 == this.Obtain.length) {
            this.highlightcurrens(this.direction);
            rowIndex = rowIndex + 1;
            this.rowIndexX = rowIndex;
            this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_0`).focus();
            this.focusinputa = `x_${rowIndex}_y_0`;
          }
        }
      }
    },

    EnterArrows(event) {
       if (event.keyCode == 9) {
         event.preventDefault();
       }
    },
    focuscilic(val, rowIndex, index, row) {
      this.MaturityDateOutFactoryDate = row;
    },
    safafafafa(val, rowIndex, index) {
      for (let i = index + 1; i < this.Obtain.length; i++) {
        if (
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_${i}`) !==
          false
        ) {
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_${i}`).focus();
          this.focusinputa = `x_${rowIndex}_y_${i}`;
          return;
        }
        if (i + 1 == this.Obtain.length) {
          this.highlightcurrens(this.direction);
          rowIndex = rowIndex + 1;
          this.distinctObj(this.$refs.Qtyfocus, `x_${rowIndex}_y_0`).focus();
          this.focusinputa = `x_${rowIndex}_y_0`;
        }
      }
    },
    initial() {
      // 进入下一个输入框
      for (let i = this.indexy + 1; i < this.Obtain.length; i++) {
        if (
          this.distinctObj(
            this.$refs.Qtyfocus,
            `x_${this.rowIndexX}_y_${i}`
          ) !== false
        ) {
          this.distinctObj(
            this.$refs.Qtyfocus,
            `x_${this.rowIndexX}_y_${i}`
          ).focus();
          this.focusinputa = `x_${this.rowIndexX}_y_${i}`;
          return;
        }
        if (i + 1 == this.Obtain.length) {
          this.highlightcurrens(this.direction);
          this.rowIndexX = this.rowIndexX + 1;
          this.distinctObj(
            this.$refs.Qtyfocus,
            `x_${this.rowIndexX}_y_0`
          ).focus();
          this.focusinputa = `x_${this.rowIndexX}_y_0`;
        }
      }
    },
  },
  mounted() {
    this.$on("footer", (val) => {
      this.childAction(ind);
    });
    let emptyData = {
      PtypeId: "", //商品Id
      FullName: "", //商品名称
      Qty: "", //数量
      AQty: "", //可用库存
      ShowPrice: "", //单价
      Total: "", //金额
      Memo: "", //备注
      Discount: "", //折扣
      DiscountPrice: "", //折后单价
      DiscountTotal: "", //折后金额
      Tax: "", //税率
      TaxPrice: "", //产品含税单价
      WithTaxTotal: "", //产品含税金额
      TaxTotal: "", //税额
      ChargePrice: "", //费用单价
      ChargeTotal: "", //费用金额
      Unit: "", //单位id
      UnitName: "", //单位名称
      PStutas: "", //销售单才传值,赠品标记,1-赠品,0-非赠品
      BString1: "", //备用字段1
      BString2: "", //备用字段2
      BString3: "", //备用字段3
      BString4: "", //备用字段4
      BString5: "", //备用字段5
      BaseNo: "", //商品编号(只显示)
      Standards: "", //规格(只显示)
      Model: "", //型号(只显示)
    };
    for (let index = this.direction; index < this.tableData.length; index++) {
      const element = this.tableData[index];
      if (element.FullName == "" && element.SalePrice) {
        this.tableData.splice(index, 1);
        this.tableData.splice(index, 0, emptyData);
      }
    }
  },
  created() {},
  computed: {
    // 当前 tab 项的 name
    currentTabIndex() {
      return this.$store.getters.GetCurrentTabIndex;
    },
  },
  watch: {
   
    // 跳转页面防止vx表格样式破坏的刷新
    currentTabIndex: {
      handler(newVal, oldVal) {
        this.$refs.xTable.recalculate();
        return;
      },
    },
    // 序列号数量弹框
    SerialTableShow: {
      handler(newVal, oldVal) {
        if (!newVal) {
          setTimeout(() => {
            this.distinctObj(this.$refs.Qtyfocus, this.focusinputa).focus(); //聚焦
            this.$refs.xTable.setCurrentRow(this.tableData[this.direction]); // 高亮第一个
            this.FullNameName = this.tableData[this.direction].FullName; //保存数据
            this.initial(); //进入下一行
          }, 300);
        }
      },
      deep: true, //对象内部的属性监听，也叫深度监听
    },
    // 多单位数量弹框
    MultipleShow: {
      handler(newVal, oldVal) {
        if (!newVal) {
          setTimeout(() => {
            this.distinctObj(this.$refs.Qtyfocus, this.focusinputa).focus(); //聚焦
            this.$refs.xTable.setCurrentRow(this.tableData[this.direction]); // 高亮第一个
            this.FullNameName = this.tableData[this.direction].FullName; //保存数据
            this.initial(); //进入下一行
          }, 300);
        }
      },
      deep: true, //对象内部的属性监听，也叫深度监听
    },
    // 选择商品是弹出的批次框
    tablebatchDialogs: {
      handler(newVal, oldVal) {
        if (!newVal) {
          setTimeout(() => {
            this.distinctObj(this.$refs.Qtyfocus, this.focusinputa).focus();
            this.$refs.xTable.setCurrentRow(this.tableData[this.direction]);
            this.FullNameName = this.tableData[this.direction].FullName;
            // this.initial();
          }, 300);
        }
      },
    },
    // 商品弹框 默认 光标
    searchShow: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.textname = "";
          setTimeout(() => {
            this.distinctObj(this.$refs.Qtyfocus, this.focusinputa).focus();
            this.$refs.xTable.setCurrentRow(this.tableData[this.direction]);
            this.FullNameName = this.tableData[this.direction].FullName;
            // this.initial();
          }, 300);
        }
      },
      deep: true, //对象内部的属性监听，也叫深度监听
    },
    tableData: {
      handler(newVal, oldVal) {
        let emptyData = {
          PtypeId: "", //商品Id
          FullName: "", //商品名称
          Qty: "", //数量
          AQty: "", //可用库存
          ShowPrice: "", //单价
          Total: "", //金额
          Memo: "", //备注
          Discount: "", //折扣
          DiscountPrice: "", //折后单价
          DiscountTotal: "", //折后金额
          Tax: "", //税率
          TaxPrice: "", //产品含税单价
          WithTaxTotal: "", //产品含税金额
          TaxTotal: "", //税额
          ChargePrice: "", //费用单价
          ChargeTotal: "", //费用金额
          Unit: "", //单位id
          UnitName: "", //单位名称
          PStutas: "", //销售单才传值,赠品标记,1-赠品,0-非赠品
          BString1: "", //备用字段1
          BString2: "", //备用字段2
          BString3: "", //备用字段3
          BString4: "", //备用字段4
          BString5: "", //备用字段5
          BaseNo: "", //商品编号(只显示)
          Standards: "", //规格(只显示)
          Model: "", //型号(只显示)
        };
        this.$refs.xTable.updateData();
        for (let index = this.direction; index < newVal.length; index++) {
          const element = newVal[index];
          if (element.FullName == "" && element.SalePrice) {
            this.tableData.splice(index, 1);
            this.tableData.splice(index, 0, emptyData);
          }
        }
        // this.$refs.xTable.updateFooter();
      },
      deep: true,
    },
    visibless: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.CommodityBaseCode = ""; //商品条码
          // this.CommodityQty = ""; // 数量
        }
      },
      deep: true,
    },
    Obtain: {
      handler(newValue, oldValue) {
        this.ObtainHeader = newValue;
        setTimeout(() => {
          this.$refs.xTable.refreshColumn(); // 更新列
          this.$refs.xTable.recalculate(); // 表格计算
          this.$refs.xTable.updateData(); // 表格刷新
        }, 500);
      },
      deep: true,
      immediate: true,
    },
    tableConfigShow: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.fsafaff = this.tableData.concat();
        } else {
          this.Data = this.fsafaff;
        }
      },
    },
  },
  destroyed() {},
};
</script>
<style lang="less" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
  // padding: 0;
}
.el-input__prefix {
  display: none;
}
/deep/ .el-input--medium .el-input__icon {
  line-height: 30px;
  display: none;
}
.el-input--medium .el-input__inner {
  border: 0;
  padding: 0 30px;
  border: 0;
}

.FunctionTable {
  /deep/ .el-input--medium .el-input__inner {
    border: 0;
  }
}

.el-input--medium,
.el-select--medium {
  height: 30px;
}
.div_box {
  width: 273px;
  height: 239px;
}

.input__icon {
  font-size: 20px;
  position: relative;
  top: 4px;
}
.input__icon:hover {
  color: aqua;
}
.Fuzzyview {
  width: 100%;
  max-height: 280px;
  background-color: aqua;
}
.input_stys {
  height: 30px;
  width: 100%;
  display: block;
  position: relative;
  -webkit-box-flex: 1;
  box-flex: 1;
  padding: 0 !important;
  background: #fff;
  display: block;
  box-sizing: border-box;
  padding: 0 0;
  border: 0; //可根据需要修改有无边框显示长度和宽带
  overflow: hidden;
  // outline: none;
  text-align: center;
}
.input_box {
  width: 100%;
  height: 30px;

  .only_show_div {
    width: 100%;
    height: 100%;
    line-height: 30px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .cliclicon {
    position: absolute;
    top: 8px;
    right: 9px;
    // display: none;
  }

  .cliclicon:hover {
    color: #0881f3;
    cursor: pointer;
  }
  .el-input__inner {
    padding: 0 5px;
  }
}
/deep/ .vxe-table .vxe-cell {
  padding: 0 !important;
}
/deep/ .vxe-table .vxe-body--column.col--ellipsis,
.vxe-table.vxe-editable .vxe-body--column,
.vxe-table .vxe-footer--column.col--ellipsis,
.vxe-table .vxe-header--column.col--ellipsis {
  height: 31px;
}
.el-button--medium {
  padding: 7px 0;
}
.el-select {
  width: 100%;
  /deep/ .el-input--mini .el-input__inner {
    height: 31px;
    line-height: 31px;
    border: 0; //可根据需要修改有无边框显示长度和宽带
    border-radius: 0;
  }
}
.btnclick {
  border: none;
  background-color: transparent;
  color: #409eff;
}
.btnclicks {
  border: none;
  background-color: transparent;
}
.Commodity_box {
  display: flex;
}
.el-input__inner {
  padding: 0;
}
/deep/ .el-dialog__header {
  padding: 0 !important;
}
/deep/ .vxe-table.vxe-editable .vxe-body--column.col--dirty:before {
  border-style: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/FunctionTable/FunctionTable.vue